import { t as e } from "./chunk-efA98nb6.js";
//#region ../../node_modules/.pnpm/html2canvas@1.4.1/node_modules/html2canvas/dist/html2canvas.js
var t = /* @__PURE__ */ e(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self, n.html2canvas = r());
	})(e, (function() {
		var e = function(t, n) {
			return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, t) {
				e.__proto__ = t;
			} || function(e, t) {
				for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
			}, e(t, n);
		};
		function t(t, n) {
			if (typeof n != "function" && n !== null) throw TypeError("Class extends value " + String(n) + " is not a constructor or null");
			e(t, n);
			function r() {
				this.constructor = t;
			}
			t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
		}
		var n = function() {
			return n = Object.assign || function(e) {
				for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n], t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
				return e;
			}, n.apply(this, arguments);
		};
		function r(e, t, n, r) {
			function i(e) {
				return e instanceof n ? e : new n(function(t) {
					t(e);
				});
			}
			return new (n ||= Promise)(function(n, a) {
				function o(e) {
					try {
						c(r.next(e));
					} catch (e) {
						a(e);
					}
				}
				function s(e) {
					try {
						c(r.throw(e));
					} catch (e) {
						a(e);
					}
				}
				function c(e) {
					e.done ? n(e.value) : i(e.value).then(o, s);
				}
				c((r = r.apply(e, t || [])).next());
			});
		}
		function i(e, t) {
			var n = {
				label: 0,
				sent: function() {
					if (a[0] & 1) throw a[1];
					return a[1];
				},
				trys: [],
				ops: []
			}, r, i, a, o;
			return o = {
				next: s(0),
				throw: s(1),
				return: s(2)
			}, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
				return this;
			}), o;
			function s(e) {
				return function(t) {
					return c([e, t]);
				};
			}
			function c(o) {
				if (r) throw TypeError("Generator is already executing.");
				for (; n;) try {
					if (r = 1, i && (a = o[0] & 2 ? i.return : o[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, o[1])).done) return a;
					switch (i = 0, a && (o = [o[0] & 2, a.value]), o[0]) {
						case 0:
						case 1:
							a = o;
							break;
						case 4: return n.label++, {
							value: o[1],
							done: !1
						};
						case 5:
							n.label++, i = o[1], o = [0];
							continue;
						case 7:
							o = n.ops.pop(), n.trys.pop();
							continue;
						default:
							if ((a = n.trys, !(a = a.length > 0 && a[a.length - 1])) && (o[0] === 6 || o[0] === 2)) {
								n = 0;
								continue;
							}
							if (o[0] === 3 && (!a || o[1] > a[0] && o[1] < a[3])) {
								n.label = o[1];
								break;
							}
							if (o[0] === 6 && n.label < a[1]) {
								n.label = a[1], a = o;
								break;
							}
							if (a && n.label < a[2]) {
								n.label = a[2], n.ops.push(o);
								break;
							}
							a[2] && n.ops.pop(), n.trys.pop();
							continue;
					}
					o = t.call(e, n);
				} catch (e) {
					o = [6, e], i = 0;
				} finally {
					r = a = 0;
				}
				if (o[0] & 5) throw o[1];
				return {
					value: o[0] ? o[1] : void 0,
					done: !0
				};
			}
		}
		function a(e, t, n) {
			if (n || arguments.length === 2) for (var r = 0, i = t.length, a; r < i; r++) (a || !(r in t)) && (a ||= Array.prototype.slice.call(t, 0, r), a[r] = t[r]);
			return e.concat(a || t);
		}
		for (var o = function() {
			function e(e, t, n, r) {
				this.left = e, this.top = t, this.width = n, this.height = r;
			}
			return e.prototype.add = function(t, n, r, i) {
				return new e(this.left + t, this.top + n, this.width + r, this.height + i);
			}, e.fromClientRect = function(t, n) {
				return new e(n.left + t.windowBounds.left, n.top + t.windowBounds.top, n.width, n.height);
			}, e.fromDOMRectList = function(t, n) {
				var r = Array.from(n).find(function(e) {
					return e.width !== 0;
				});
				return r ? new e(r.left + t.windowBounds.left, r.top + t.windowBounds.top, r.width, r.height) : e.EMPTY;
			}, e.EMPTY = new e(0, 0, 0, 0), e;
		}(), s = function(e, t) {
			return o.fromClientRect(e, t.getBoundingClientRect());
		}, c = function(e) {
			var t = e.body, n = e.documentElement;
			if (!t || !n) throw Error("Unable to get document size");
			return new o(0, 0, Math.max(Math.max(t.scrollWidth, n.scrollWidth), Math.max(t.offsetWidth, n.offsetWidth), Math.max(t.clientWidth, n.clientWidth)), Math.max(Math.max(t.scrollHeight, n.scrollHeight), Math.max(t.offsetHeight, n.offsetHeight), Math.max(t.clientHeight, n.clientHeight)));
		}, l = function(e) {
			for (var t = [], n = 0, r = e.length; n < r;) {
				var i = e.charCodeAt(n++);
				if (i >= 55296 && i <= 56319 && n < r) {
					var a = e.charCodeAt(n++);
					(a & 64512) == 56320 ? t.push(((i & 1023) << 10) + (a & 1023) + 65536) : (t.push(i), n--);
				} else t.push(i);
			}
			return t;
		}, u = function() {
			var e = [...arguments];
			if (String.fromCodePoint) return String.fromCodePoint.apply(String, e);
			var t = e.length;
			if (!t) return "";
			for (var n = [], r = -1, i = ""; ++r < t;) {
				var a = e[r];
				a <= 65535 ? n.push(a) : (a -= 65536, n.push((a >> 10) + 55296, a % 1024 + 56320)), (r + 1 === t || n.length > 16384) && (i += String.fromCharCode.apply(String, n), n.length = 0);
			}
			return i;
		}, d = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", f = typeof Uint8Array > "u" ? [] : new Uint8Array(256), p = 0; p < d.length; p++) f[d.charCodeAt(p)] = p;
		for (var m = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", h = typeof Uint8Array > "u" ? [] : new Uint8Array(256), g = 0; g < m.length; g++) h[m.charCodeAt(g)] = g;
		for (var _ = function(e) {
			var t = e.length * .75, n = e.length, r, i = 0, a, o, s, c;
			e[e.length - 1] === "=" && (t--, e[e.length - 2] === "=" && t--);
			var l = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && Uint8Array.prototype.slice !== void 0 ? new ArrayBuffer(t) : Array(t), u = Array.isArray(l) ? l : new Uint8Array(l);
			for (r = 0; r < n; r += 4) a = h[e.charCodeAt(r)], o = h[e.charCodeAt(r + 1)], s = h[e.charCodeAt(r + 2)], c = h[e.charCodeAt(r + 3)], u[i++] = a << 2 | o >> 4, u[i++] = (o & 15) << 4 | s >> 2, u[i++] = (s & 3) << 6 | c & 63;
			return l;
		}, v = function(e) {
			for (var t = e.length, n = [], r = 0; r < t; r += 2) n.push(e[r + 1] << 8 | e[r]);
			return n;
		}, y = function(e) {
			for (var t = e.length, n = [], r = 0; r < t; r += 4) n.push(e[r + 3] << 24 | e[r + 2] << 16 | e[r + 1] << 8 | e[r]);
			return n;
		}, b = 5, x = 11, S = 2, C = x - b, w = 65536 >> b, T = (1 << b) - 1, E = w + (1024 >> b) + 32, D = 65536 >> x, O = (1 << C) - 1, ee = function(e, t, n) {
			return e.slice ? e.slice(t, n) : new Uint16Array(Array.prototype.slice.call(e, t, n));
		}, te = function(e, t, n) {
			return e.slice ? e.slice(t, n) : new Uint32Array(Array.prototype.slice.call(e, t, n));
		}, ne = function(e, t) {
			var n = _(e), r = Array.isArray(n) ? y(n) : new Uint32Array(n), i = Array.isArray(n) ? v(n) : new Uint16Array(n), a = 24, o = ee(i, a / 2, r[4] / 2), s = r[5] === 2 ? ee(i, (a + r[4]) / 2) : te(r, Math.ceil((a + r[4]) / 4));
			return new re(r[0], r[1], r[2], r[3], o, s);
		}, re = function() {
			function e(e, t, n, r, i, a) {
				this.initialValue = e, this.errorValue = t, this.highStart = n, this.highValueIndex = r, this.index = i, this.data = a;
			}
			return e.prototype.get = function(e) {
				var t;
				if (e >= 0) {
					if (e < 55296 || e > 56319 && e <= 65535) return t = this.index[e >> b], t = (t << S) + (e & T), this.data[t];
					if (e <= 65535) return t = this.index[w + (e - 55296 >> b)], t = (t << S) + (e & T), this.data[t];
					if (e < this.highStart) return t = E - D + (e >> x), t = this.index[t], t += e >> b & O, t = this.index[t], t = (t << S) + (e & T), this.data[t];
					if (e <= 1114111) return this.data[this.highValueIndex];
				}
				return this.errorValue;
			}, e;
		}(), ie = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", ae = typeof Uint8Array > "u" ? [] : new Uint8Array(256), oe = 0; oe < ie.length; oe++) ae[ie.charCodeAt(oe)] = oe;
		var se = "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", ce = 50, le = 1, ue = 2, de = 3, fe = 4, pe = 5, me = 7, he = 8, ge = 9, _e = 10, ve = 11, ye = 12, be = 13, xe = 14, Se = 15, Ce = 16, we = 17, Te = 18, Ee = 19, De = 20, Oe = 21, ke = 22, Ae = 23, je = 24, k = 25, Me = 26, Ne = 27, Pe = 28, Fe = 29, Ie = 30, Le = 31, Re = 32, ze = 33, Be = 34, Ve = 35, He = 36, Ue = 37, We = 38, Ge = 39, Ke = 40, qe = 41, Je = 42, Ye = 43, Xe = [9001, 65288], Ze = "!", A = "×", Qe = "÷", $e = ne(se), j = [Ie, He], et = [
			le,
			ue,
			de,
			pe
		], tt = [_e, he], nt = [Ne, Me], rt = et.concat(tt), it = [
			We,
			Ge,
			Ke,
			Be,
			Ve
		], at = [Se, be], ot = function(e, t) {
			t === void 0 && (t = "strict");
			var n = [], r = [], i = [];
			return e.forEach(function(e, a) {
				var o = $e.get(e);
				if (o > ce ? (i.push(!0), o -= ce) : i.push(!1), [
					"normal",
					"auto",
					"loose"
				].indexOf(t) !== -1 && [
					8208,
					8211,
					12316,
					12448
				].indexOf(e) !== -1) return r.push(a), n.push(Ce);
				if (o === fe || o === ve) {
					if (a === 0) return r.push(a), n.push(Ie);
					var s = n[a - 1];
					return rt.indexOf(s) === -1 ? (r.push(r[a - 1]), n.push(s)) : (r.push(a), n.push(Ie));
				}
				if (r.push(a), o === Le) return n.push(t === "strict" ? Oe : Ue);
				if (o === Je || o === Fe) return n.push(Ie);
				if (o === Ye) return e >= 131072 && e <= 196605 || e >= 196608 && e <= 262141 ? n.push(Ue) : n.push(Ie);
				n.push(o);
			}), [
				r,
				n,
				i
			];
		}, st = function(e, t, n, r) {
			var i = r[n];
			if (Array.isArray(e) ? e.indexOf(i) !== -1 : e === i) for (var a = n; a <= r.length;) {
				a++;
				var o = r[a];
				if (o === t) return !0;
				if (o !== _e) break;
			}
			if (i === _e) for (var a = n; a > 0;) {
				a--;
				var s = r[a];
				if (Array.isArray(e) ? e.indexOf(s) !== -1 : e === s) for (var c = n; c <= r.length;) {
					c++;
					var o = r[c];
					if (o === t) return !0;
					if (o !== _e) break;
				}
				if (s !== _e) break;
			}
			return !1;
		}, ct = function(e, t) {
			for (var n = e; n >= 0;) {
				var r = t[n];
				if (r === _e) n--;
				else return r;
			}
			return 0;
		}, lt = function(e, t, n, r, i) {
			if (n[r] === 0) return A;
			var a = r - 1;
			if (Array.isArray(i) && i[a] === !0) return A;
			var o = a - 1, s = a + 1, c = t[a], l = o >= 0 ? t[o] : 0, u = t[s];
			if (c === ue && u === de) return A;
			if (et.indexOf(c) !== -1) return Ze;
			if (et.indexOf(u) !== -1 || tt.indexOf(u) !== -1) return A;
			if (ct(a, t) === he) return Qe;
			if ($e.get(e[a]) === ve || (c === Re || c === ze) && $e.get(e[s]) === ve || c === me || u === me || c === ge || [
				_e,
				be,
				Se
			].indexOf(c) === -1 && u === ge || [
				we,
				Te,
				Ee,
				je,
				Pe
			].indexOf(u) !== -1 || ct(a, t) === ke || st(Ae, ke, a, t) || st([we, Te], Oe, a, t) || st(ye, ye, a, t)) return A;
			if (c === _e) return Qe;
			if (c === Ae || u === Ae) return A;
			if (u === Ce || c === Ce) return Qe;
			if ([
				be,
				Se,
				Oe
			].indexOf(u) !== -1 || c === xe || l === He && at.indexOf(c) !== -1 || c === Pe && u === He || u === De || j.indexOf(u) !== -1 && c === k || j.indexOf(c) !== -1 && u === k || c === Ne && [
				Ue,
				Re,
				ze
			].indexOf(u) !== -1 || [
				Ue,
				Re,
				ze
			].indexOf(c) !== -1 && u === Me || j.indexOf(c) !== -1 && nt.indexOf(u) !== -1 || nt.indexOf(c) !== -1 && j.indexOf(u) !== -1 || [Ne, Me].indexOf(c) !== -1 && (u === k || [ke, Se].indexOf(u) !== -1 && t[s + 1] === k) || [ke, Se].indexOf(c) !== -1 && u === k || c === k && [
				k,
				Pe,
				je
			].indexOf(u) !== -1) return A;
			if ([
				k,
				Pe,
				je,
				we,
				Te
			].indexOf(u) !== -1) for (var d = a; d >= 0;) {
				var f = t[d];
				if (f === k) return A;
				if ([Pe, je].indexOf(f) !== -1) d--;
				else break;
			}
			if ([Ne, Me].indexOf(u) !== -1) for (var d = [we, Te].indexOf(c) === -1 ? a : o; d >= 0;) {
				var f = t[d];
				if (f === k) return A;
				if ([Pe, je].indexOf(f) !== -1) d--;
				else break;
			}
			if (We === c && [
				We,
				Ge,
				Be,
				Ve
			].indexOf(u) !== -1 || [Ge, Be].indexOf(c) !== -1 && [Ge, Ke].indexOf(u) !== -1 || [Ke, Ve].indexOf(c) !== -1 && u === Ke || it.indexOf(c) !== -1 && [De, Me].indexOf(u) !== -1 || it.indexOf(u) !== -1 && c === Ne || j.indexOf(c) !== -1 && j.indexOf(u) !== -1 || c === je && j.indexOf(u) !== -1 || j.concat(k).indexOf(c) !== -1 && u === ke && Xe.indexOf(e[s]) === -1 || j.concat(k).indexOf(u) !== -1 && c === Te) return A;
			if (c === qe && u === qe) {
				for (var p = n[a], m = 1; p > 0 && (p--, t[p] === qe);) m++;
				if (m % 2 != 0) return A;
			}
			return c === Re && u === ze ? A : Qe;
		}, ut = function(e, t) {
			t ||= {
				lineBreak: "normal",
				wordBreak: "normal"
			};
			var n = ot(e, t.lineBreak), r = n[0], i = n[1], a = n[2];
			(t.wordBreak === "break-all" || t.wordBreak === "break-word") && (i = i.map(function(e) {
				return [
					k,
					Ie,
					Je
				].indexOf(e) === -1 ? e : Ue;
			}));
			var o = t.wordBreak === "keep-all" ? a.map(function(t, n) {
				return t && e[n] >= 19968 && e[n] <= 40959;
			}) : void 0;
			return [
				r,
				i,
				o
			];
		}, dt = function() {
			function e(e, t, n, r) {
				this.codePoints = e, this.required = t === Ze, this.start = n, this.end = r;
			}
			return e.prototype.slice = function() {
				return u.apply(void 0, this.codePoints.slice(this.start, this.end));
			}, e;
		}(), ft = function(e, t) {
			var n = l(e), r = ut(n, t), i = r[0], a = r[1], o = r[2], s = n.length, c = 0, u = 0;
			return { next: function() {
				if (u >= s) return {
					done: !0,
					value: null
				};
				for (var e = A; u < s && (e = lt(n, a, i, ++u, o)) === A;);
				if (e !== A || u === s) {
					var t = new dt(n, e, c, u);
					return c = u, {
						value: t,
						done: !1
					};
				}
				return {
					done: !0,
					value: null
				};
			} };
		}, pt = 1, mt = 2, ht = 4, gt = 8, _t = 10, vt = 47, yt = 92, bt = 9, xt = 32, St = 34, Ct = 61, wt = 35, Tt = 36, Et = 37, Dt = 39, Ot = 40, kt = 41, At = 95, M = 45, jt = 33, Mt = 60, Nt = 62, Pt = 64, Ft = 91, It = 93, Lt = 61, Rt = 123, zt = 63, Bt = 125, Vt = 124, Ht = 126, Ut = 128, Wt = 65533, Gt = 42, Kt = 43, qt = 44, Jt = 58, Yt = 59, Xt = 46, Zt = 0, Qt = 8, $t = 11, en = 14, tn = 31, nn = 127, N = -1, rn = 48, an = 97, on = 101, sn = 102, cn = 117, ln = 122, un = 65, dn = 69, fn = 70, pn = 85, mn = 90, P = function(e) {
			return e >= rn && e <= 57;
		}, hn = function(e) {
			return e >= 55296 && e <= 57343;
		}, gn = function(e) {
			return P(e) || e >= un && e <= fn || e >= an && e <= sn;
		}, _n = function(e) {
			return e >= an && e <= ln;
		}, vn = function(e) {
			return e >= un && e <= mn;
		}, yn = function(e) {
			return _n(e) || vn(e);
		}, bn = function(e) {
			return e >= Ut;
		}, xn = function(e) {
			return e === _t || e === bt || e === xt;
		}, Sn = function(e) {
			return yn(e) || bn(e) || e === At;
		}, Cn = function(e) {
			return Sn(e) || P(e) || e === M;
		}, wn = function(e) {
			return e >= Zt && e <= Qt || e === $t || e >= en && e <= tn || e === nn;
		}, Tn = function(e, t) {
			return e === yt ? t !== _t : !1;
		}, En = function(e, t, n) {
			return e === M ? Sn(t) || Tn(t, n) : Sn(e) ? !0 : !!(e === yt && Tn(e, t));
		}, Dn = function(e, t, n) {
			return e === Kt || e === M ? P(t) ? !0 : t === Xt && P(n) : P(e === Xt ? t : e);
		}, On = function(e) {
			var t = 0, n = 1;
			(e[t] === Kt || e[t] === M) && (e[t] === M && (n = -1), t++);
			for (var r = []; P(e[t]);) r.push(e[t++]);
			var i = r.length ? parseInt(u.apply(void 0, r), 10) : 0;
			e[t] === Xt && t++;
			for (var a = []; P(e[t]);) a.push(e[t++]);
			var o = a.length, s = o ? parseInt(u.apply(void 0, a), 10) : 0;
			(e[t] === dn || e[t] === on) && t++;
			var c = 1;
			(e[t] === Kt || e[t] === M) && (e[t] === M && (c = -1), t++);
			for (var l = []; P(e[t]);) l.push(e[t++]);
			var d = l.length ? parseInt(u.apply(void 0, l), 10) : 0;
			return n * (i + s * 10 ** -o) * 10 ** (c * d);
		}, kn = { type: 2 }, An = { type: 3 }, jn = { type: 4 }, Mn = { type: 13 }, Nn = { type: 8 }, Pn = { type: 21 }, Fn = { type: 9 }, In = { type: 10 }, Ln = { type: 11 }, Rn = { type: 12 }, zn = { type: 14 }, Bn = { type: 23 }, Vn = { type: 1 }, Hn = { type: 25 }, Un = { type: 24 }, Wn = { type: 26 }, Gn = { type: 27 }, Kn = { type: 28 }, qn = { type: 29 }, Jn = { type: 31 }, Yn = { type: 32 }, Xn = function() {
			function e() {
				this._value = [];
			}
			return e.prototype.write = function(e) {
				this._value = this._value.concat(l(e));
			}, e.prototype.read = function() {
				for (var e = [], t = this.consumeToken(); t !== Yn;) e.push(t), t = this.consumeToken();
				return e;
			}, e.prototype.consumeToken = function() {
				var e = this.consumeCodePoint();
				switch (e) {
					case St: return this.consumeStringToken(St);
					case wt:
						var t = this.peekCodePoint(0), n = this.peekCodePoint(1), r = this.peekCodePoint(2);
						if (Cn(t) || Tn(n, r)) {
							var i = En(t, n, r) ? mt : pt, a = this.consumeName();
							return {
								type: 5,
								value: a,
								flags: i
							};
						}
						break;
					case Tt:
						if (this.peekCodePoint(0) === Ct) return this.consumeCodePoint(), Mn;
						break;
					case Dt: return this.consumeStringToken(Dt);
					case Ot: return kn;
					case kt: return An;
					case Gt:
						if (this.peekCodePoint(0) === Ct) return this.consumeCodePoint(), zn;
						break;
					case Kt:
						if (Dn(e, this.peekCodePoint(0), this.peekCodePoint(1))) return this.reconsumeCodePoint(e), this.consumeNumericToken();
						break;
					case qt: return jn;
					case M:
						var o = e, s = this.peekCodePoint(0), c = this.peekCodePoint(1);
						if (Dn(o, s, c)) return this.reconsumeCodePoint(e), this.consumeNumericToken();
						if (En(o, s, c)) return this.reconsumeCodePoint(e), this.consumeIdentLikeToken();
						if (s === M && c === Nt) return this.consumeCodePoint(), this.consumeCodePoint(), Un;
						break;
					case Xt:
						if (Dn(e, this.peekCodePoint(0), this.peekCodePoint(1))) return this.reconsumeCodePoint(e), this.consumeNumericToken();
						break;
					case vt:
						if (this.peekCodePoint(0) === Gt) for (this.consumeCodePoint();;) {
							var l = this.consumeCodePoint();
							if (l === Gt && (l = this.consumeCodePoint(), l === vt) || l === N) return this.consumeToken();
						}
						break;
					case Jt: return Wn;
					case Yt: return Gn;
					case Mt:
						if (this.peekCodePoint(0) === jt && this.peekCodePoint(1) === M && this.peekCodePoint(2) === M) return this.consumeCodePoint(), this.consumeCodePoint(), Hn;
						break;
					case Pt:
						if (En(this.peekCodePoint(0), this.peekCodePoint(1), this.peekCodePoint(2))) {
							var a = this.consumeName();
							return {
								type: 7,
								value: a
							};
						}
						break;
					case Ft: return Kn;
					case yt:
						if (Tn(e, this.peekCodePoint(0))) return this.reconsumeCodePoint(e), this.consumeIdentLikeToken();
						break;
					case It: return qn;
					case Lt:
						if (this.peekCodePoint(0) === Ct) return this.consumeCodePoint(), Nn;
						break;
					case Rt: return Ln;
					case Bt: return Rn;
					case cn:
					case pn:
						var d = this.peekCodePoint(0), f = this.peekCodePoint(1);
						return d === Kt && (gn(f) || f === zt) && (this.consumeCodePoint(), this.consumeUnicodeRangeToken()), this.reconsumeCodePoint(e), this.consumeIdentLikeToken();
					case Vt:
						if (this.peekCodePoint(0) === Ct) return this.consumeCodePoint(), Fn;
						if (this.peekCodePoint(0) === Vt) return this.consumeCodePoint(), Pn;
						break;
					case Ht:
						if (this.peekCodePoint(0) === Ct) return this.consumeCodePoint(), In;
						break;
					case N: return Yn;
				}
				return xn(e) ? (this.consumeWhiteSpace(), Jn) : P(e) ? (this.reconsumeCodePoint(e), this.consumeNumericToken()) : Sn(e) ? (this.reconsumeCodePoint(e), this.consumeIdentLikeToken()) : {
					type: 6,
					value: u(e)
				};
			}, e.prototype.consumeCodePoint = function() {
				var e = this._value.shift();
				return e === void 0 ? -1 : e;
			}, e.prototype.reconsumeCodePoint = function(e) {
				this._value.unshift(e);
			}, e.prototype.peekCodePoint = function(e) {
				return e >= this._value.length ? -1 : this._value[e];
			}, e.prototype.consumeUnicodeRangeToken = function() {
				for (var e = [], t = this.consumeCodePoint(); gn(t) && e.length < 6;) e.push(t), t = this.consumeCodePoint();
				for (var n = !1; t === zt && e.length < 6;) e.push(t), t = this.consumeCodePoint(), n = !0;
				if (n) {
					var r = parseInt(u.apply(void 0, e.map(function(e) {
						return e === zt ? rn : e;
					})), 16), i = parseInt(u.apply(void 0, e.map(function(e) {
						return e === zt ? fn : e;
					})), 16);
					return {
						type: 30,
						start: r,
						end: i
					};
				}
				var a = parseInt(u.apply(void 0, e), 16);
				if (this.peekCodePoint(0) === M && gn(this.peekCodePoint(1))) {
					this.consumeCodePoint(), t = this.consumeCodePoint();
					for (var o = []; gn(t) && o.length < 6;) o.push(t), t = this.consumeCodePoint();
					var i = parseInt(u.apply(void 0, o), 16);
					return {
						type: 30,
						start: a,
						end: i
					};
				} else return {
					type: 30,
					start: a,
					end: a
				};
			}, e.prototype.consumeIdentLikeToken = function() {
				var e = this.consumeName();
				return e.toLowerCase() === "url" && this.peekCodePoint(0) === Ot ? (this.consumeCodePoint(), this.consumeUrlToken()) : this.peekCodePoint(0) === Ot ? (this.consumeCodePoint(), {
					type: 19,
					value: e
				}) : {
					type: 20,
					value: e
				};
			}, e.prototype.consumeUrlToken = function() {
				var e = [];
				if (this.consumeWhiteSpace(), this.peekCodePoint(0) === N) return {
					type: 22,
					value: ""
				};
				var t = this.peekCodePoint(0);
				if (t === Dt || t === St) {
					var n = this.consumeStringToken(this.consumeCodePoint());
					return n.type === 0 && (this.consumeWhiteSpace(), this.peekCodePoint(0) === N || this.peekCodePoint(0) === kt) ? (this.consumeCodePoint(), {
						type: 22,
						value: n.value
					}) : (this.consumeBadUrlRemnants(), Bn);
				}
				for (;;) {
					var r = this.consumeCodePoint();
					if (r === N || r === kt) return {
						type: 22,
						value: u.apply(void 0, e)
					};
					if (xn(r)) return this.consumeWhiteSpace(), this.peekCodePoint(0) === N || this.peekCodePoint(0) === kt ? (this.consumeCodePoint(), {
						type: 22,
						value: u.apply(void 0, e)
					}) : (this.consumeBadUrlRemnants(), Bn);
					if (r === St || r === Dt || r === Ot || wn(r)) return this.consumeBadUrlRemnants(), Bn;
					if (r === yt) if (Tn(r, this.peekCodePoint(0))) e.push(this.consumeEscapedCodePoint());
					else return this.consumeBadUrlRemnants(), Bn;
					else e.push(r);
				}
			}, e.prototype.consumeWhiteSpace = function() {
				for (; xn(this.peekCodePoint(0));) this.consumeCodePoint();
			}, e.prototype.consumeBadUrlRemnants = function() {
				for (;;) {
					var e = this.consumeCodePoint();
					if (e === kt || e === N) return;
					Tn(e, this.peekCodePoint(0)) && this.consumeEscapedCodePoint();
				}
			}, e.prototype.consumeStringSlice = function(e) {
				for (var t = 5e4, n = ""; e > 0;) {
					var r = Math.min(t, e);
					n += u.apply(void 0, this._value.splice(0, r)), e -= r;
				}
				return this._value.shift(), n;
			}, e.prototype.consumeStringToken = function(e) {
				var t = "", n = 0;
				do {
					var r = this._value[n];
					if (r === N || r === void 0 || r === e) return t += this.consumeStringSlice(n), {
						type: 0,
						value: t
					};
					if (r === _t) return this._value.splice(0, n), Vn;
					if (r === yt) {
						var i = this._value[n + 1];
						i !== N && i !== void 0 && (i === _t ? (t += this.consumeStringSlice(n), n = -1, this._value.shift()) : Tn(r, i) && (t += this.consumeStringSlice(n), t += u(this.consumeEscapedCodePoint()), n = -1));
					}
					n++;
				} while (!0);
			}, e.prototype.consumeNumber = function() {
				var e = [], t = ht, n = this.peekCodePoint(0);
				for ((n === Kt || n === M) && e.push(this.consumeCodePoint()); P(this.peekCodePoint(0));) e.push(this.consumeCodePoint());
				n = this.peekCodePoint(0);
				var r = this.peekCodePoint(1);
				if (n === Xt && P(r)) for (e.push(this.consumeCodePoint(), this.consumeCodePoint()), t = gt; P(this.peekCodePoint(0));) e.push(this.consumeCodePoint());
				n = this.peekCodePoint(0), r = this.peekCodePoint(1);
				var i = this.peekCodePoint(2);
				if ((n === dn || n === on) && ((r === Kt || r === M) && P(i) || P(r))) for (e.push(this.consumeCodePoint(), this.consumeCodePoint()), t = gt; P(this.peekCodePoint(0));) e.push(this.consumeCodePoint());
				return [On(e), t];
			}, e.prototype.consumeNumericToken = function() {
				var e = this.consumeNumber(), t = e[0], n = e[1], r = this.peekCodePoint(0);
				return En(r, this.peekCodePoint(1), this.peekCodePoint(2)) ? {
					type: 15,
					number: t,
					flags: n,
					unit: this.consumeName()
				} : r === Et ? (this.consumeCodePoint(), {
					type: 16,
					number: t,
					flags: n
				}) : {
					type: 17,
					number: t,
					flags: n
				};
			}, e.prototype.consumeEscapedCodePoint = function() {
				var e = this.consumeCodePoint();
				if (gn(e)) {
					for (var t = u(e); gn(this.peekCodePoint(0)) && t.length < 6;) t += u(this.consumeCodePoint());
					xn(this.peekCodePoint(0)) && this.consumeCodePoint();
					var n = parseInt(t, 16);
					return n === 0 || hn(n) || n > 1114111 ? Wt : n;
				}
				return e === N ? Wt : e;
			}, e.prototype.consumeName = function() {
				for (var e = "";;) {
					var t = this.consumeCodePoint();
					if (Cn(t)) e += u(t);
					else if (Tn(t, this.peekCodePoint(0))) e += u(this.consumeEscapedCodePoint());
					else return this.reconsumeCodePoint(t), e;
				}
			}, e;
		}(), Zn = function() {
			function e(e) {
				this._tokens = e;
			}
			return e.create = function(t) {
				var n = new Xn();
				return n.write(t), new e(n.read());
			}, e.parseValue = function(t) {
				return e.create(t).parseComponentValue();
			}, e.parseValues = function(t) {
				return e.create(t).parseComponentValues();
			}, e.prototype.parseComponentValue = function() {
				for (var e = this.consumeToken(); e.type === 31;) e = this.consumeToken();
				if (e.type === 32) throw SyntaxError("Error parsing CSS component value, unexpected EOF");
				this.reconsumeToken(e);
				var t = this.consumeComponentValue();
				do
					e = this.consumeToken();
				while (e.type === 31);
				if (e.type === 32) return t;
				throw SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
			}, e.prototype.parseComponentValues = function() {
				for (var e = [];;) {
					var t = this.consumeComponentValue();
					if (t.type === 32) return e;
					e.push(t), e.push();
				}
			}, e.prototype.consumeComponentValue = function() {
				var e = this.consumeToken();
				switch (e.type) {
					case 11:
					case 28:
					case 2: return this.consumeSimpleBlock(e.type);
					case 19: return this.consumeFunction(e);
				}
				return e;
			}, e.prototype.consumeSimpleBlock = function(e) {
				for (var t = {
					type: e,
					values: []
				}, n = this.consumeToken();;) {
					if (n.type === 32 || ir(n, e)) return t;
					this.reconsumeToken(n), t.values.push(this.consumeComponentValue()), n = this.consumeToken();
				}
			}, e.prototype.consumeFunction = function(e) {
				for (var t = {
					name: e.value,
					values: [],
					type: 18
				};;) {
					var n = this.consumeToken();
					if (n.type === 32 || n.type === 3) return t;
					this.reconsumeToken(n), t.values.push(this.consumeComponentValue());
				}
			}, e.prototype.consumeToken = function() {
				var e = this._tokens.shift();
				return e === void 0 ? Yn : e;
			}, e.prototype.reconsumeToken = function(e) {
				this._tokens.unshift(e);
			}, e;
		}(), Qn = function(e) {
			return e.type === 15;
		}, $n = function(e) {
			return e.type === 17;
		}, F = function(e) {
			return e.type === 20;
		}, er = function(e) {
			return e.type === 0;
		}, tr = function(e, t) {
			return F(e) && e.value === t;
		}, nr = function(e) {
			return e.type !== 31;
		}, rr = function(e) {
			return e.type !== 31 && e.type !== 4;
		}, I = function(e) {
			var t = [], n = [];
			return e.forEach(function(e) {
				if (e.type === 4) {
					if (n.length === 0) throw Error("Error parsing function args, zero tokens for arg");
					t.push(n), n = [];
					return;
				}
				e.type !== 31 && n.push(e);
			}), n.length && t.push(n), t;
		}, ir = function(e, t) {
			return t === 11 && e.type === 12 || t === 28 && e.type === 29 ? !0 : t === 2 && e.type === 3;
		}, ar = function(e) {
			return e.type === 17 || e.type === 15;
		}, L = function(e) {
			return e.type === 16 || ar(e);
		}, or = function(e) {
			return e.length > 1 ? [e[0], e[1]] : [e[0]];
		}, R = {
			type: 17,
			number: 0,
			flags: ht
		}, sr = {
			type: 16,
			number: 50,
			flags: ht
		}, cr = {
			type: 16,
			number: 100,
			flags: ht
		}, lr = function(e, t, n) {
			var r = e[0], i = e[1];
			return [z(r, t), z(i === void 0 ? r : i, n)];
		}, z = function(e, t) {
			if (e.type === 16) return e.number / 100 * t;
			if (Qn(e)) switch (e.unit) {
				case "rem":
				case "em": return 16 * e.number;
				default: return e.number;
			}
			return e.number;
		}, ur = "deg", dr = "grad", fr = "rad", pr = "turn", mr = {
			name: "angle",
			parse: function(e, t) {
				if (t.type === 15) switch (t.unit) {
					case ur: return Math.PI * t.number / 180;
					case dr: return Math.PI / 200 * t.number;
					case fr: return t.number;
					case pr: return Math.PI * 2 * t.number;
				}
				throw Error("Unsupported angle type");
			}
		}, hr = function(e) {
			return e.type === 15 && (e.unit === ur || e.unit === dr || e.unit === fr || e.unit === pr);
		}, gr = function(e) {
			switch (e.filter(F).map(function(e) {
				return e.value;
			}).join(" ")) {
				case "to bottom right":
				case "to right bottom":
				case "left top":
				case "top left": return [R, R];
				case "to top":
				case "bottom": return B(0);
				case "to bottom left":
				case "to left bottom":
				case "right top":
				case "top right": return [R, cr];
				case "to right":
				case "left": return B(90);
				case "to top left":
				case "to left top":
				case "right bottom":
				case "bottom right": return [cr, cr];
				case "to bottom":
				case "top": return B(180);
				case "to top right":
				case "to right top":
				case "left bottom":
				case "bottom left": return [cr, R];
				case "to left":
				case "right": return B(270);
			}
			return 0;
		}, B = function(e) {
			return Math.PI * e / 180;
		}, _r = {
			name: "color",
			parse: function(e, t) {
				if (t.type === 18) {
					var n = wr[t.name];
					if (n === void 0) throw Error("Attempting to parse an unsupported color function \"" + t.name + "\"");
					return n(e, t.values);
				}
				if (t.type === 5) {
					if (t.value.length === 3) {
						var r = t.value.substring(0, 1), i = t.value.substring(1, 2), a = t.value.substring(2, 3);
						return yr(parseInt(r + r, 16), parseInt(i + i, 16), parseInt(a + a, 16), 1);
					}
					if (t.value.length === 4) {
						var r = t.value.substring(0, 1), i = t.value.substring(1, 2), a = t.value.substring(2, 3), o = t.value.substring(3, 4);
						return yr(parseInt(r + r, 16), parseInt(i + i, 16), parseInt(a + a, 16), parseInt(o + o, 16) / 255);
					}
					if (t.value.length === 6) {
						var r = t.value.substring(0, 2), i = t.value.substring(2, 4), a = t.value.substring(4, 6);
						return yr(parseInt(r, 16), parseInt(i, 16), parseInt(a, 16), 1);
					}
					if (t.value.length === 8) {
						var r = t.value.substring(0, 2), i = t.value.substring(2, 4), a = t.value.substring(4, 6), o = t.value.substring(6, 8);
						return yr(parseInt(r, 16), parseInt(i, 16), parseInt(a, 16), parseInt(o, 16) / 255);
					}
				}
				if (t.type === 20) {
					var s = H[t.value.toUpperCase()];
					if (s !== void 0) return s;
				}
				return H.TRANSPARENT;
			}
		}, vr = function(e) {
			return (255 & e) == 0;
		}, V = function(e) {
			var t = 255 & e, n = 255 & e >> 8, r = 255 & e >> 16, i = 255 & e >> 24;
			return t < 255 ? "rgba(" + i + "," + r + "," + n + "," + t / 255 + ")" : "rgb(" + i + "," + r + "," + n + ")";
		}, yr = function(e, t, n, r) {
			return (e << 24 | t << 16 | n << 8 | Math.round(r * 255) << 0) >>> 0;
		}, br = function(e, t) {
			if (e.type === 17) return e.number;
			if (e.type === 16) {
				var n = t === 3 ? 1 : 255;
				return t === 3 ? e.number / 100 * n : Math.round(e.number / 100 * n);
			}
			return 0;
		}, xr = function(e, t) {
			var n = t.filter(rr);
			if (n.length === 3) {
				var r = n.map(br), i = r[0], a = r[1], o = r[2];
				return yr(i, a, o, 1);
			}
			if (n.length === 4) {
				var s = n.map(br), i = s[0], a = s[1], o = s[2], c = s[3];
				return yr(i, a, o, c);
			}
			return 0;
		};
		function Sr(e, t, n) {
			return n < 0 && (n += 1), n >= 1 && --n, n < 1 / 6 ? (t - e) * n * 6 + e : n < 1 / 2 ? t : n < 2 / 3 ? (t - e) * 6 * (2 / 3 - n) + e : e;
		}
		var Cr = function(e, t) {
			var n = t.filter(rr), r = n[0], i = n[1], a = n[2], o = n[3], s = (r.type === 17 ? B(r.number) : mr.parse(e, r)) / (Math.PI * 2), c = L(i) ? i.number / 100 : 0, l = L(a) ? a.number / 100 : 0, u = o !== void 0 && L(o) ? z(o, 1) : 1;
			if (c === 0) return yr(l * 255, l * 255, l * 255, 1);
			var d = l <= .5 ? l * (c + 1) : l + c - l * c, f = l * 2 - d, p = Sr(f, d, s + 1 / 3), m = Sr(f, d, s), h = Sr(f, d, s - 1 / 3);
			return yr(p * 255, m * 255, h * 255, u);
		}, wr = {
			hsl: Cr,
			hsla: Cr,
			rgb: xr,
			rgba: xr
		}, Tr = function(e, t) {
			return _r.parse(e, Zn.create(t).parseComponentValue());
		}, H = {
			ALICEBLUE: 4042850303,
			ANTIQUEWHITE: 4209760255,
			AQUA: 16777215,
			AQUAMARINE: 2147472639,
			AZURE: 4043309055,
			BEIGE: 4126530815,
			BISQUE: 4293182719,
			BLACK: 255,
			BLANCHEDALMOND: 4293643775,
			BLUE: 65535,
			BLUEVIOLET: 2318131967,
			BROWN: 2771004159,
			BURLYWOOD: 3736635391,
			CADETBLUE: 1604231423,
			CHARTREUSE: 2147418367,
			CHOCOLATE: 3530104575,
			CORAL: 4286533887,
			CORNFLOWERBLUE: 1687547391,
			CORNSILK: 4294499583,
			CRIMSON: 3692313855,
			CYAN: 16777215,
			DARKBLUE: 35839,
			DARKCYAN: 9145343,
			DARKGOLDENROD: 3095837695,
			DARKGRAY: 2846468607,
			DARKGREEN: 6553855,
			DARKGREY: 2846468607,
			DARKKHAKI: 3182914559,
			DARKMAGENTA: 2332068863,
			DARKOLIVEGREEN: 1433087999,
			DARKORANGE: 4287365375,
			DARKORCHID: 2570243327,
			DARKRED: 2332033279,
			DARKSALMON: 3918953215,
			DARKSEAGREEN: 2411499519,
			DARKSLATEBLUE: 1211993087,
			DARKSLATEGRAY: 793726975,
			DARKSLATEGREY: 793726975,
			DARKTURQUOISE: 13554175,
			DARKVIOLET: 2483082239,
			DEEPPINK: 4279538687,
			DEEPSKYBLUE: 12582911,
			DIMGRAY: 1768516095,
			DIMGREY: 1768516095,
			DODGERBLUE: 512819199,
			FIREBRICK: 2988581631,
			FLORALWHITE: 4294635775,
			FORESTGREEN: 579543807,
			FUCHSIA: 4278255615,
			GAINSBORO: 3705462015,
			GHOSTWHITE: 4177068031,
			GOLD: 4292280575,
			GOLDENROD: 3668254975,
			GRAY: 2155905279,
			GREEN: 8388863,
			GREENYELLOW: 2919182335,
			GREY: 2155905279,
			HONEYDEW: 4043305215,
			HOTPINK: 4285117695,
			INDIANRED: 3445382399,
			INDIGO: 1258324735,
			IVORY: 4294963455,
			KHAKI: 4041641215,
			LAVENDER: 3873897215,
			LAVENDERBLUSH: 4293981695,
			LAWNGREEN: 2096890111,
			LEMONCHIFFON: 4294626815,
			LIGHTBLUE: 2916673279,
			LIGHTCORAL: 4034953471,
			LIGHTCYAN: 3774873599,
			LIGHTGOLDENRODYELLOW: 4210742015,
			LIGHTGRAY: 3553874943,
			LIGHTGREEN: 2431553791,
			LIGHTGREY: 3553874943,
			LIGHTPINK: 4290167295,
			LIGHTSALMON: 4288707327,
			LIGHTSEAGREEN: 548580095,
			LIGHTSKYBLUE: 2278488831,
			LIGHTSLATEGRAY: 2005441023,
			LIGHTSLATEGREY: 2005441023,
			LIGHTSTEELBLUE: 2965692159,
			LIGHTYELLOW: 4294959359,
			LIME: 16711935,
			LIMEGREEN: 852308735,
			LINEN: 4210091775,
			MAGENTA: 4278255615,
			MAROON: 2147483903,
			MEDIUMAQUAMARINE: 1724754687,
			MEDIUMBLUE: 52735,
			MEDIUMORCHID: 3126187007,
			MEDIUMPURPLE: 2473647103,
			MEDIUMSEAGREEN: 1018393087,
			MEDIUMSLATEBLUE: 2070474495,
			MEDIUMSPRINGGREEN: 16423679,
			MEDIUMTURQUOISE: 1221709055,
			MEDIUMVIOLETRED: 3340076543,
			MIDNIGHTBLUE: 421097727,
			MINTCREAM: 4127193855,
			MISTYROSE: 4293190143,
			MOCCASIN: 4293178879,
			NAVAJOWHITE: 4292783615,
			NAVY: 33023,
			OLDLACE: 4260751103,
			OLIVE: 2155872511,
			OLIVEDRAB: 1804477439,
			ORANGE: 4289003775,
			ORANGERED: 4282712319,
			ORCHID: 3664828159,
			PALEGOLDENROD: 4008225535,
			PALEGREEN: 2566625535,
			PALETURQUOISE: 2951671551,
			PALEVIOLETRED: 3681588223,
			PAPAYAWHIP: 4293907967,
			PEACHPUFF: 4292524543,
			PERU: 3448061951,
			PINK: 4290825215,
			PLUM: 3718307327,
			POWDERBLUE: 2967529215,
			PURPLE: 2147516671,
			REBECCAPURPLE: 1714657791,
			RED: 4278190335,
			ROSYBROWN: 3163525119,
			ROYALBLUE: 1097458175,
			SADDLEBROWN: 2336560127,
			SALMON: 4202722047,
			SANDYBROWN: 4104413439,
			SEAGREEN: 780883967,
			SEASHELL: 4294307583,
			SIENNA: 2689740287,
			SILVER: 3233857791,
			SKYBLUE: 2278484991,
			SLATEBLUE: 1784335871,
			SLATEGRAY: 1887473919,
			SLATEGREY: 1887473919,
			SNOW: 4294638335,
			SPRINGGREEN: 16744447,
			STEELBLUE: 1182971135,
			TAN: 3535047935,
			TEAL: 8421631,
			THISTLE: 3636451583,
			TOMATO: 4284696575,
			TRANSPARENT: 0,
			TURQUOISE: 1088475391,
			VIOLET: 4001558271,
			WHEAT: 4125012991,
			WHITE: 4294967295,
			WHITESMOKE: 4126537215,
			YELLOW: 4294902015,
			YELLOWGREEN: 2597139199
		}, Er = {
			name: "background-clip",
			initialValue: "border-box",
			prefix: !1,
			type: 1,
			parse: function(e, t) {
				return t.map(function(e) {
					if (F(e)) switch (e.value) {
						case "padding-box": return 1;
						case "content-box": return 2;
					}
					return 0;
				});
			}
		}, Dr = {
			name: "background-color",
			initialValue: "transparent",
			prefix: !1,
			type: 3,
			format: "color"
		}, Or = function(e, t) {
			var n = _r.parse(e, t[0]), r = t[1];
			return r && L(r) ? {
				color: n,
				stop: r
			} : {
				color: n,
				stop: null
			};
		}, kr = function(e, t) {
			var n = e[0], r = e[e.length - 1];
			n.stop === null && (n.stop = R), r.stop === null && (r.stop = cr);
			for (var i = [], a = 0, o = 0; o < e.length; o++) {
				var s = e[o].stop;
				if (s !== null) {
					var c = z(s, t);
					c > a ? i.push(c) : i.push(a), a = c;
				} else i.push(null);
			}
			for (var l = null, o = 0; o < i.length; o++) {
				var u = i[o];
				if (u === null) l === null && (l = o);
				else if (l !== null) {
					for (var d = o - l, f = (u - i[l - 1]) / (d + 1), p = 1; p <= d; p++) i[l + p - 1] = f * p;
					l = null;
				}
			}
			return e.map(function(e, n) {
				return {
					color: e.color,
					stop: Math.max(Math.min(1, i[n] / t), 0)
				};
			});
		}, Ar = function(e, t, n) {
			var r = t / 2, i = n / 2, a = z(e[0], t) - r, o = i - z(e[1], n);
			return (Math.atan2(o, a) + Math.PI * 2) % (Math.PI * 2);
		}, jr = function(e, t, n) {
			var r = typeof e == "number" ? e : Ar(e, t, n), i = Math.abs(t * Math.sin(r)) + Math.abs(n * Math.cos(r)), a = t / 2, o = n / 2, s = i / 2, c = Math.sin(r - Math.PI / 2) * s, l = Math.cos(r - Math.PI / 2) * s;
			return [
				i,
				a - l,
				a + l,
				o - c,
				o + c
			];
		}, U = function(e, t) {
			return Math.sqrt(e * e + t * t);
		}, Mr = function(e, t, n, r, i) {
			return [
				[0, 0],
				[0, t],
				[e, 0],
				[e, t]
			].reduce(function(e, t) {
				var a = t[0], o = t[1], s = U(n - a, r - o);
				return (i ? s < e.optimumDistance : s > e.optimumDistance) ? {
					optimumCorner: t,
					optimumDistance: s
				} : e;
			}, {
				optimumDistance: i ? Infinity : -Infinity,
				optimumCorner: null
			}).optimumCorner;
		}, Nr = function(e, t, n, r, i) {
			var a = 0, o = 0;
			switch (e.size) {
				case 0:
					e.shape === 0 ? a = o = Math.min(Math.abs(t), Math.abs(t - r), Math.abs(n), Math.abs(n - i)) : e.shape === 1 && (a = Math.min(Math.abs(t), Math.abs(t - r)), o = Math.min(Math.abs(n), Math.abs(n - i)));
					break;
				case 2:
					if (e.shape === 0) a = o = Math.min(U(t, n), U(t, n - i), U(t - r, n), U(t - r, n - i));
					else if (e.shape === 1) {
						var s = Math.min(Math.abs(n), Math.abs(n - i)) / Math.min(Math.abs(t), Math.abs(t - r)), c = Mr(r, i, t, n, !0), l = c[0], u = c[1];
						a = U(l - t, (u - n) / s), o = s * a;
					}
					break;
				case 1:
					e.shape === 0 ? a = o = Math.max(Math.abs(t), Math.abs(t - r), Math.abs(n), Math.abs(n - i)) : e.shape === 1 && (a = Math.max(Math.abs(t), Math.abs(t - r)), o = Math.max(Math.abs(n), Math.abs(n - i)));
					break;
				case 3:
					if (e.shape === 0) a = o = Math.max(U(t, n), U(t, n - i), U(t - r, n), U(t - r, n - i));
					else if (e.shape === 1) {
						var s = Math.max(Math.abs(n), Math.abs(n - i)) / Math.max(Math.abs(t), Math.abs(t - r)), d = Mr(r, i, t, n, !1), l = d[0], u = d[1];
						a = U(l - t, (u - n) / s), o = s * a;
					}
					break;
			}
			return Array.isArray(e.size) && (a = z(e.size[0], r), o = e.size.length === 2 ? z(e.size[1], i) : a), [a, o];
		}, Pr = function(e, t) {
			var n = B(180), r = [];
			return I(t).forEach(function(t, i) {
				if (i === 0) {
					var a = t[0];
					if (a.type === 20 && a.value === "to") {
						n = gr(t);
						return;
					} else if (hr(a)) {
						n = mr.parse(e, a);
						return;
					}
				}
				var o = Or(e, t);
				r.push(o);
			}), {
				angle: n,
				stops: r,
				type: 1
			};
		}, Fr = function(e, t) {
			var n = B(180), r = [];
			return I(t).forEach(function(t, i) {
				if (i === 0) {
					var a = t[0];
					if (a.type === 20 && [
						"top",
						"left",
						"right",
						"bottom"
					].indexOf(a.value) !== -1) {
						n = gr(t);
						return;
					} else if (hr(a)) {
						n = (mr.parse(e, a) + B(270)) % B(360);
						return;
					}
				}
				var o = Or(e, t);
				r.push(o);
			}), {
				angle: n,
				stops: r,
				type: 1
			};
		}, Ir = function(e, t) {
			var n = B(180), r = [], i = 1;
			return I(t).forEach(function(t, n) {
				var a = t[0];
				if (n === 0) {
					if (F(a) && a.value === "linear") {
						i = 1;
						return;
					} else if (F(a) && a.value === "radial") {
						i = 2;
						return;
					}
				}
				if (a.type === 18) {
					if (a.name === "from") {
						var o = _r.parse(e, a.values[0]);
						r.push({
							stop: R,
							color: o
						});
					} else if (a.name === "to") {
						var o = _r.parse(e, a.values[0]);
						r.push({
							stop: cr,
							color: o
						});
					} else if (a.name === "color-stop") {
						var s = a.values.filter(rr);
						if (s.length === 2) {
							var o = _r.parse(e, s[1]), c = s[0];
							$n(c) && r.push({
								stop: {
									type: 16,
									number: c.number * 100,
									flags: c.flags
								},
								color: o
							});
						}
					}
				}
			}), i === 1 ? {
				angle: (n + B(180)) % B(360),
				stops: r,
				type: i
			} : {
				size: 3,
				shape: 0,
				stops: r,
				position: [],
				type: i
			};
		}, Lr = "closest-side", Rr = "farthest-side", zr = "closest-corner", Br = "farthest-corner", Vr = "circle", Hr = "ellipse", Ur = "cover", Wr = "contain", Gr = function(e, t) {
			var n = 0, r = 3, i = [], a = [];
			return I(t).forEach(function(t, o) {
				var s = !0;
				if (o === 0) {
					var c = !1;
					s = t.reduce(function(e, t) {
						if (c) if (F(t)) switch (t.value) {
							case "center": return a.push(sr), e;
							case "top":
							case "left": return a.push(R), e;
							case "right":
							case "bottom": return a.push(cr), e;
						}
						else (L(t) || ar(t)) && a.push(t);
						else if (F(t)) switch (t.value) {
							case Vr: return n = 0, !1;
							case Hr: return n = 1, !1;
							case "at": return c = !0, !1;
							case Lr: return r = 0, !1;
							case Ur:
							case Rr: return r = 1, !1;
							case Wr:
							case zr: return r = 2, !1;
							case Br: return r = 3, !1;
						}
						else if (ar(t) || L(t)) return Array.isArray(r) || (r = []), r.push(t), !1;
						return e;
					}, s);
				}
				if (s) {
					var l = Or(e, t);
					i.push(l);
				}
			}), {
				size: r,
				shape: n,
				stops: i,
				position: a,
				type: 2
			};
		}, Kr = function(e, t) {
			var n = 0, r = 3, i = [], a = [];
			return I(t).forEach(function(t, o) {
				var s = !0;
				if (o === 0 ? s = t.reduce(function(e, t) {
					if (F(t)) switch (t.value) {
						case "center": return a.push(sr), !1;
						case "top":
						case "left": return a.push(R), !1;
						case "right":
						case "bottom": return a.push(cr), !1;
					}
					else if (L(t) || ar(t)) return a.push(t), !1;
					return e;
				}, s) : o === 1 && (s = t.reduce(function(e, t) {
					if (F(t)) switch (t.value) {
						case Vr: return n = 0, !1;
						case Hr: return n = 1, !1;
						case Wr:
						case Lr: return r = 0, !1;
						case Rr: return r = 1, !1;
						case zr: return r = 2, !1;
						case Ur:
						case Br: return r = 3, !1;
					}
					else if (ar(t) || L(t)) return Array.isArray(r) || (r = []), r.push(t), !1;
					return e;
				}, s)), s) {
					var c = Or(e, t);
					i.push(c);
				}
			}), {
				size: r,
				shape: n,
				stops: i,
				position: a,
				type: 2
			};
		}, qr = function(e) {
			return e.type === 1;
		}, Jr = function(e) {
			return e.type === 2;
		}, Yr = {
			name: "image",
			parse: function(e, t) {
				if (t.type === 22) {
					var n = {
						url: t.value,
						type: 0
					};
					return e.cache.addImage(t.value), n;
				}
				if (t.type === 18) {
					var r = Zr[t.name];
					if (r === void 0) throw Error("Attempting to parse an unsupported image function \"" + t.name + "\"");
					return r(e, t.values);
				}
				throw Error("Unsupported image type " + t.type);
			}
		};
		function Xr(e) {
			return !(e.type === 20 && e.value === "none") && (e.type !== 18 || !!Zr[e.name]);
		}
		var Zr = {
			"linear-gradient": Pr,
			"-moz-linear-gradient": Fr,
			"-ms-linear-gradient": Fr,
			"-o-linear-gradient": Fr,
			"-webkit-linear-gradient": Fr,
			"radial-gradient": Gr,
			"-moz-radial-gradient": Kr,
			"-ms-radial-gradient": Kr,
			"-o-radial-gradient": Kr,
			"-webkit-radial-gradient": Kr,
			"-webkit-gradient": Ir
		}, Qr = {
			name: "background-image",
			initialValue: "none",
			type: 1,
			prefix: !1,
			parse: function(e, t) {
				if (t.length === 0) return [];
				var n = t[0];
				return n.type === 20 && n.value === "none" ? [] : t.filter(function(e) {
					return rr(e) && Xr(e);
				}).map(function(t) {
					return Yr.parse(e, t);
				});
			}
		}, $r = {
			name: "background-origin",
			initialValue: "border-box",
			prefix: !1,
			type: 1,
			parse: function(e, t) {
				return t.map(function(e) {
					if (F(e)) switch (e.value) {
						case "padding-box": return 1;
						case "content-box": return 2;
					}
					return 0;
				});
			}
		}, ei = {
			name: "background-position",
			initialValue: "0% 0%",
			type: 1,
			prefix: !1,
			parse: function(e, t) {
				return I(t).map(function(e) {
					return e.filter(L);
				}).map(or);
			}
		}, ti = {
			name: "background-repeat",
			initialValue: "repeat",
			prefix: !1,
			type: 1,
			parse: function(e, t) {
				return I(t).map(function(e) {
					return e.filter(F).map(function(e) {
						return e.value;
					}).join(" ");
				}).map(ni);
			}
		}, ni = function(e) {
			switch (e) {
				case "no-repeat": return 1;
				case "repeat-x":
				case "repeat no-repeat": return 2;
				case "repeat-y":
				case "no-repeat repeat": return 3;
				default: return 0;
			}
		}, ri;
		(function(e) {
			e.AUTO = "auto", e.CONTAIN = "contain", e.COVER = "cover";
		})(ri ||= {});
		var ii = {
			name: "background-size",
			initialValue: "0",
			prefix: !1,
			type: 1,
			parse: function(e, t) {
				return I(t).map(function(e) {
					return e.filter(ai);
				});
			}
		}, ai = function(e) {
			return F(e) || L(e);
		}, oi = function(e) {
			return {
				name: "border-" + e + "-color",
				initialValue: "transparent",
				prefix: !1,
				type: 3,
				format: "color"
			};
		}, si = oi("top"), ci = oi("right"), li = oi("bottom"), ui = oi("left"), di = function(e) {
			return {
				name: "border-radius-" + e,
				initialValue: "0 0",
				prefix: !1,
				type: 1,
				parse: function(e, t) {
					return or(t.filter(L));
				}
			};
		}, fi = di("top-left"), pi = di("top-right"), mi = di("bottom-right"), hi = di("bottom-left"), gi = function(e) {
			return {
				name: "border-" + e + "-style",
				initialValue: "solid",
				prefix: !1,
				type: 2,
				parse: function(e, t) {
					switch (t) {
						case "none": return 0;
						case "dashed": return 2;
						case "dotted": return 3;
						case "double": return 4;
					}
					return 1;
				}
			};
		}, _i = gi("top"), vi = gi("right"), yi = gi("bottom"), bi = gi("left"), xi = function(e) {
			return {
				name: "border-" + e + "-width",
				initialValue: "0",
				type: 0,
				prefix: !1,
				parse: function(e, t) {
					return Qn(t) ? t.number : 0;
				}
			};
		}, Si = xi("top"), Ci = xi("right"), wi = xi("bottom"), Ti = xi("left"), Ei = {
			name: "color",
			initialValue: "transparent",
			prefix: !1,
			type: 3,
			format: "color"
		}, Di = {
			name: "direction",
			initialValue: "ltr",
			prefix: !1,
			type: 2,
			parse: function(e, t) {
				switch (t) {
					case "rtl": return 1;
					default: return 0;
				}
			}
		}, Oi = {
			name: "display",
			initialValue: "inline-block",
			prefix: !1,
			type: 1,
			parse: function(e, t) {
				return t.filter(F).reduce(function(e, t) {
					return e | ki(t.value);
				}, 0);
			}
		}, ki = function(e) {
			switch (e) {
				case "block":
				case "-webkit-box": return 2;
				case "inline": return 4;
				case "run-in": return 8;
				case "flow": return 16;
				case "flow-root": return 32;
				case "table": return 64;
				case "flex":
				case "-webkit-flex": return 128;
				case "grid":
				case "-ms-grid": return 256;
				case "ruby": return 512;
				case "subgrid": return 1024;
				case "list-item": return 2048;
				case "table-row-group": return 4096;
				case "table-header-group": return 8192;
				case "table-footer-group": return 16384;
				case "table-row": return 32768;
				case "table-cell": return 65536;
				case "table-column-group": return 131072;
				case "table-column": return 262144;
				case "table-caption": return 524288;
				case "ruby-base": return 1048576;
				case "ruby-text": return 2097152;
				case "ruby-base-container": return 4194304;
				case "ruby-text-container": return 8388608;
				case "contents": return 16777216;
				case "inline-block": return 33554432;
				case "inline-list-item": return 67108864;
				case "inline-table": return 134217728;
				case "inline-flex": return 268435456;
				case "inline-grid": return 536870912;
			}
			return 0;
		}, Ai = {
			name: "float",
			initialValue: "none",
			prefix: !1,
			type: 2,
			parse: function(e, t) {
				switch (t) {
					case "left": return 1;
					case "right": return 2;
					case "inline-start": return 3;
					case "inline-end": return 4;
				}
				return 0;
			}
		}, ji = {
			name: "letter-spacing",
			initialValue: "0",
			prefix: !1,
			type: 0,
			parse: function(e, t) {
				return t.type === 20 && t.value === "normal" ? 0 : t.type === 17 || t.type === 15 ? t.number : 0;
			}
		}, Mi;
		(function(e) {
			e.NORMAL = "normal", e.STRICT = "strict";
		})(Mi ||= {});
		var Ni = {
			name: "line-break",
			initialValue: "normal",
			prefix: !1,
			type: 2,
			parse: function(e, t) {
				switch (t) {
					case "strict": return Mi.STRICT;
					default: return Mi.NORMAL;
				}
			}
		}, Pi = {
			name: "line-height",
			initialValue: "normal",
			prefix: !1,
			type: 4
		}, Fi = function(e, t) {
			return F(e) && e.value === "normal" ? 1.2 * t : e.type === 17 ? t * e.number : L(e) ? z(e, t) : t;
		}, Ii = {
			name: "list-style-image",
			initialValue: "none",
			type: 0,
			prefix: !1,
			parse: function(e, t) {
				return t.type === 20 && t.value === "none" ? null : Yr.parse(e, t);
			}
		}, Li = {
			name: "list-style-position",
			initialValue: "outside",
			prefix: !1,
			type: 2,
			parse: function(e, t) {
				switch (t) {
					case "inside": return 0;
					default: return 1;
				}
			}
		}, Ri = {
			name: "list-style-type",
			initialValue: "none",
			prefix: !1,
			type: 2,
			parse: function(e, t) {
				switch (t) {
					case "disc": return 0;
					case "circle": return 1;
					case "square": return 2;
					case "decimal": return 3;
					case "cjk-decimal": return 4;
					case "decimal-leading-zero": return 5;
					case "lower-roman": return 6;
					case "upper-roman": return 7;
					case "lower-greek": return 8;
					case "lower-alpha": return 9;
					case "upper-alpha": return 10;
					case "arabic-indic": return 11;
					case "armenian": return 12;
					case "bengali": return 13;
					case "cambodian": return 14;
					case "cjk-earthly-branch": return 15;
					case "cjk-heavenly-stem": return 16;
					case "cjk-ideographic": return 17;
					case "devanagari": return 18;
					case "ethiopic-numeric": return 19;
					case "georgian": return 20;
					case "gujarati": return 21;
					case "gurmukhi": return 22;
					case "hebrew": return 22;
					case "hiragana": return 23;
					case "hiragana-iroha": return 24;
					case "japanese-formal": return 25;
					case "japanese-informal": return 26;
					case "kannada": return 27;
					case "katakana": return 28;
					case "katakana-iroha": return 29;
					case "khmer": return 30;
					case "korean-hangul-formal": return 31;
					case "korean-hanja-formal": return 32;
					case "korean-hanja-informal": return 33;
					case "lao": return 34;
					case "lower-armenian": return 35;
					case "malayalam": return 36;
					case "mongolian": return 37;
					case "myanmar": return 38;
					case "oriya": return 39;
					case "persian": return 40;
					case "simp-chinese-formal": return 41;
					case "simp-chinese-informal": return 42;
					case "tamil": return 43;
					case "telugu": return 44;
					case "thai": return 45;
					case "tibetan": return 46;
					case "trad-chinese-formal": return 47;
					case "trad-chinese-informal": return 48;
					case "upper-armenian": return 49;
					case "disclosure-open": return 50;
					case "disclosure-closed": return 51;
					default: return -1;
				}
			}
		}, zi = function(e) {
			return {
				name: "margin-" + e,
				initialValue: "0",
				prefix: !1,
				type: 4
			};
		}, Bi = zi("top"), Vi = zi("right"), Hi = zi("bottom"), Ui = zi("left"), Wi = {
			name: "overflow",
			initialValue: "visible",
			prefix: !1,
			type: 1,
			parse: function(e, t) {
				return t.filter(F).map(function(e) {
					switch (e.value) {
						case "hidden": return 1;
						case "scroll": return 2;
						case "clip": return 3;
						case "auto": return 4;
						default: return 0;
					}
				});
			}
		}, Gi = {
			name: "overflow-wrap",
			initialValue: "normal",
			prefix: !1,
			type: 2,
			parse: function(e, t) {
				switch (t) {
					case "break-word": return "break-word";
					default: return "normal";
				}
			}
		}, Ki = function(e) {
			return {
				name: "padding-" + e,
				initialValue: "0",
				prefix: !1,
				type: 3,
				format: "length-percentage"
			};
		}, qi = Ki("top"), Ji = Ki("right"), Yi = Ki("bottom"), Xi = Ki("left"), Zi = {
			name: "text-align",
			initialValue: "left",
			prefix: !1,
			type: 2,
			parse: function(e, t) {
				switch (t) {
					case "right": return 2;
					case "center":
					case "justify": return 1;
					default: return 0;
				}
			}
		}, Qi = {
			name: "position",
			initialValue: "static",
			prefix: !1,
			type: 2,
			parse: function(e, t) {
				switch (t) {
					case "relative": return 1;
					case "absolute": return 2;
					case "fixed": return 3;
					case "sticky": return 4;
				}
				return 0;
			}
		}, $i = {
			name: "text-shadow",
			initialValue: "none",
			type: 1,
			prefix: !1,
			parse: function(e, t) {
				return t.length === 1 && tr(t[0], "none") ? [] : I(t).map(function(t) {
					for (var n = {
						color: H.TRANSPARENT,
						offsetX: R,
						offsetY: R,
						blur: R
					}, r = 0, i = 0; i < t.length; i++) {
						var a = t[i];
						ar(a) ? (r === 0 ? n.offsetX = a : r === 1 ? n.offsetY = a : n.blur = a, r++) : n.color = _r.parse(e, a);
					}
					return n;
				});
			}
		}, ea = {
			name: "text-transform",
			initialValue: "none",
			prefix: !1,
			type: 2,
			parse: function(e, t) {
				switch (t) {
					case "uppercase": return 2;
					case "lowercase": return 1;
					case "capitalize": return 3;
				}
				return 0;
			}
		}, ta = {
			name: "transform",
			initialValue: "none",
			prefix: !0,
			type: 0,
			parse: function(e, t) {
				if (t.type === 20 && t.value === "none") return null;
				if (t.type === 18) {
					var n = na[t.name];
					if (n === void 0) throw Error("Attempting to parse an unsupported transform function \"" + t.name + "\"");
					return n(t.values);
				}
				return null;
			}
		}, na = {
			matrix: function(e) {
				var t = e.filter(function(e) {
					return e.type === 17;
				}).map(function(e) {
					return e.number;
				});
				return t.length === 6 ? t : null;
			},
			matrix3d: function(e) {
				var t = e.filter(function(e) {
					return e.type === 17;
				}).map(function(e) {
					return e.number;
				}), n = t[0], r = t[1];
				t[2], t[3];
				var i = t[4], a = t[5];
				t[6], t[7], t[8], t[9], t[10], t[11];
				var o = t[12], s = t[13];
				return t[14], t[15], t.length === 16 ? [
					n,
					r,
					i,
					a,
					o,
					s
				] : null;
			}
		}, ra = {
			type: 16,
			number: 50,
			flags: ht
		}, ia = [ra, ra], aa = {
			name: "transform-origin",
			initialValue: "50% 50%",
			prefix: !0,
			type: 1,
			parse: function(e, t) {
				var n = t.filter(L);
				return n.length === 2 ? [n[0], n[1]] : ia;
			}
		}, oa = {
			name: "visible",
			initialValue: "none",
			prefix: !1,
			type: 2,
			parse: function(e, t) {
				switch (t) {
					case "hidden": return 1;
					case "collapse": return 2;
					default: return 0;
				}
			}
		}, sa;
		(function(e) {
			e.NORMAL = "normal", e.BREAK_ALL = "break-all", e.KEEP_ALL = "keep-all";
		})(sa ||= {});
		for (var ca = {
			name: "word-break",
			initialValue: "normal",
			prefix: !1,
			type: 2,
			parse: function(e, t) {
				switch (t) {
					case "break-all": return sa.BREAK_ALL;
					case "keep-all": return sa.KEEP_ALL;
					default: return sa.NORMAL;
				}
			}
		}, la = {
			name: "z-index",
			initialValue: "auto",
			prefix: !1,
			type: 0,
			parse: function(e, t) {
				if (t.type === 20) return {
					auto: !0,
					order: 0
				};
				if ($n(t)) return {
					auto: !1,
					order: t.number
				};
				throw Error("Invalid z-index number parsed");
			}
		}, ua = {
			name: "time",
			parse: function(e, t) {
				if (t.type === 15) switch (t.unit.toLowerCase()) {
					case "s": return 1e3 * t.number;
					case "ms": return t.number;
				}
				throw Error("Unsupported time type");
			}
		}, da = {
			name: "opacity",
			initialValue: "1",
			type: 0,
			prefix: !1,
			parse: function(e, t) {
				return $n(t) ? t.number : 1;
			}
		}, fa = {
			name: "text-decoration-color",
			initialValue: "transparent",
			prefix: !1,
			type: 3,
			format: "color"
		}, pa = {
			name: "text-decoration-line",
			initialValue: "none",
			prefix: !1,
			type: 1,
			parse: function(e, t) {
				return t.filter(F).map(function(e) {
					switch (e.value) {
						case "underline": return 1;
						case "overline": return 2;
						case "line-through": return 3;
						case "none": return 4;
					}
					return 0;
				}).filter(function(e) {
					return e !== 0;
				});
			}
		}, ma = {
			name: "font-family",
			initialValue: "",
			prefix: !1,
			type: 1,
			parse: function(e, t) {
				var n = [], r = [];
				return t.forEach(function(e) {
					switch (e.type) {
						case 20:
						case 0:
							n.push(e.value);
							break;
						case 17:
							n.push(e.number.toString());
							break;
						case 4:
							r.push(n.join(" ")), n.length = 0;
							break;
					}
				}), n.length && r.push(n.join(" ")), r.map(function(e) {
					return e.indexOf(" ") === -1 ? e : "'" + e + "'";
				});
			}
		}, ha = {
			name: "font-size",
			initialValue: "0",
			prefix: !1,
			type: 3,
			format: "length"
		}, ga = {
			name: "font-weight",
			initialValue: "normal",
			type: 0,
			prefix: !1,
			parse: function(e, t) {
				if ($n(t)) return t.number;
				if (F(t)) switch (t.value) {
					case "bold": return 700;
					default: return 400;
				}
				return 400;
			}
		}, _a = {
			name: "font-variant",
			initialValue: "none",
			type: 1,
			prefix: !1,
			parse: function(e, t) {
				return t.filter(F).map(function(e) {
					return e.value;
				});
			}
		}, va = {
			name: "font-style",
			initialValue: "normal",
			prefix: !1,
			type: 2,
			parse: function(e, t) {
				switch (t) {
					case "oblique": return "oblique";
					case "italic": return "italic";
					default: return "normal";
				}
			}
		}, W = function(e, t) {
			return (e & t) !== 0;
		}, ya = {
			name: "content",
			initialValue: "none",
			type: 1,
			prefix: !1,
			parse: function(e, t) {
				if (t.length === 0) return [];
				var n = t[0];
				return n.type === 20 && n.value === "none" ? [] : t;
			}
		}, ba = {
			name: "counter-increment",
			initialValue: "none",
			prefix: !0,
			type: 1,
			parse: function(e, t) {
				if (t.length === 0) return null;
				var n = t[0];
				if (n.type === 20 && n.value === "none") return null;
				for (var r = [], i = t.filter(nr), a = 0; a < i.length; a++) {
					var o = i[a], s = i[a + 1];
					if (o.type === 20) {
						var c = s && $n(s) ? s.number : 1;
						r.push({
							counter: o.value,
							increment: c
						});
					}
				}
				return r;
			}
		}, xa = {
			name: "counter-reset",
			initialValue: "none",
			prefix: !0,
			type: 1,
			parse: function(e, t) {
				if (t.length === 0) return [];
				for (var n = [], r = t.filter(nr), i = 0; i < r.length; i++) {
					var a = r[i], o = r[i + 1];
					if (F(a) && a.value !== "none") {
						var s = o && $n(o) ? o.number : 0;
						n.push({
							counter: a.value,
							reset: s
						});
					}
				}
				return n;
			}
		}, Sa = {
			name: "duration",
			initialValue: "0s",
			prefix: !1,
			type: 1,
			parse: function(e, t) {
				return t.filter(Qn).map(function(t) {
					return ua.parse(e, t);
				});
			}
		}, Ca = {
			name: "quotes",
			initialValue: "none",
			prefix: !0,
			type: 1,
			parse: function(e, t) {
				if (t.length === 0) return null;
				var n = t[0];
				if (n.type === 20 && n.value === "none") return null;
				var r = [], i = t.filter(er);
				if (i.length % 2 != 0) return null;
				for (var a = 0; a < i.length; a += 2) {
					var o = i[a].value, s = i[a + 1].value;
					r.push({
						open: o,
						close: s
					});
				}
				return r;
			}
		}, wa = function(e, t, n) {
			if (!e) return "";
			var r = e[Math.min(t, e.length - 1)];
			return r ? n ? r.open : r.close : "";
		}, Ta = {
			name: "box-shadow",
			initialValue: "none",
			type: 1,
			prefix: !1,
			parse: function(e, t) {
				return t.length === 1 && tr(t[0], "none") ? [] : I(t).map(function(t) {
					for (var n = {
						color: 255,
						offsetX: R,
						offsetY: R,
						blur: R,
						spread: R,
						inset: !1
					}, r = 0, i = 0; i < t.length; i++) {
						var a = t[i];
						tr(a, "inset") ? n.inset = !0 : ar(a) ? (r === 0 ? n.offsetX = a : r === 1 ? n.offsetY = a : r === 2 ? n.blur = a : n.spread = a, r++) : n.color = _r.parse(e, a);
					}
					return n;
				});
			}
		}, Ea = {
			name: "paint-order",
			initialValue: "normal",
			prefix: !1,
			type: 1,
			parse: function(e, t) {
				var n = [
					0,
					1,
					2
				], r = [];
				return t.filter(F).forEach(function(e) {
					switch (e.value) {
						case "stroke":
							r.push(1);
							break;
						case "fill":
							r.push(0);
							break;
						case "markers":
							r.push(2);
							break;
					}
				}), n.forEach(function(e) {
					r.indexOf(e) === -1 && r.push(e);
				}), r;
			}
		}, Da = {
			name: "-webkit-text-stroke-color",
			initialValue: "currentcolor",
			prefix: !1,
			type: 3,
			format: "color"
		}, Oa = {
			name: "-webkit-text-stroke-width",
			initialValue: "0",
			type: 0,
			prefix: !1,
			parse: function(e, t) {
				return Qn(t) ? t.number : 0;
			}
		}, ka = function() {
			function e(e, t) {
				this.animationDuration = G(e, Sa, t.animationDuration), this.backgroundClip = G(e, Er, t.backgroundClip), this.backgroundColor = G(e, Dr, t.backgroundColor), this.backgroundImage = G(e, Qr, t.backgroundImage), this.backgroundOrigin = G(e, $r, t.backgroundOrigin), this.backgroundPosition = G(e, ei, t.backgroundPosition), this.backgroundRepeat = G(e, ti, t.backgroundRepeat), this.backgroundSize = G(e, ii, t.backgroundSize), this.borderTopColor = G(e, si, t.borderTopColor), this.borderRightColor = G(e, ci, t.borderRightColor), this.borderBottomColor = G(e, li, t.borderBottomColor), this.borderLeftColor = G(e, ui, t.borderLeftColor), this.borderTopLeftRadius = G(e, fi, t.borderTopLeftRadius), this.borderTopRightRadius = G(e, pi, t.borderTopRightRadius), this.borderBottomRightRadius = G(e, mi, t.borderBottomRightRadius), this.borderBottomLeftRadius = G(e, hi, t.borderBottomLeftRadius), this.borderTopStyle = G(e, _i, t.borderTopStyle), this.borderRightStyle = G(e, vi, t.borderRightStyle), this.borderBottomStyle = G(e, yi, t.borderBottomStyle), this.borderLeftStyle = G(e, bi, t.borderLeftStyle), this.borderTopWidth = G(e, Si, t.borderTopWidth), this.borderRightWidth = G(e, Ci, t.borderRightWidth), this.borderBottomWidth = G(e, wi, t.borderBottomWidth), this.borderLeftWidth = G(e, Ti, t.borderLeftWidth), this.boxShadow = G(e, Ta, t.boxShadow), this.color = G(e, Ei, t.color), this.direction = G(e, Di, t.direction), this.display = G(e, Oi, t.display), this.float = G(e, Ai, t.cssFloat), this.fontFamily = G(e, ma, t.fontFamily), this.fontSize = G(e, ha, t.fontSize), this.fontStyle = G(e, va, t.fontStyle), this.fontVariant = G(e, _a, t.fontVariant), this.fontWeight = G(e, ga, t.fontWeight), this.letterSpacing = G(e, ji, t.letterSpacing), this.lineBreak = G(e, Ni, t.lineBreak), this.lineHeight = G(e, Pi, t.lineHeight), this.listStyleImage = G(e, Ii, t.listStyleImage), this.listStylePosition = G(e, Li, t.listStylePosition), this.listStyleType = G(e, Ri, t.listStyleType), this.marginTop = G(e, Bi, t.marginTop), this.marginRight = G(e, Vi, t.marginRight), this.marginBottom = G(e, Hi, t.marginBottom), this.marginLeft = G(e, Ui, t.marginLeft), this.opacity = G(e, da, t.opacity);
				var n = G(e, Wi, t.overflow);
				this.overflowX = n[0], this.overflowY = n[n.length > 1 ? 1 : 0], this.overflowWrap = G(e, Gi, t.overflowWrap), this.paddingTop = G(e, qi, t.paddingTop), this.paddingRight = G(e, Ji, t.paddingRight), this.paddingBottom = G(e, Yi, t.paddingBottom), this.paddingLeft = G(e, Xi, t.paddingLeft), this.paintOrder = G(e, Ea, t.paintOrder), this.position = G(e, Qi, t.position), this.textAlign = G(e, Zi, t.textAlign), this.textDecorationColor = G(e, fa, t.textDecorationColor ?? t.color), this.textDecorationLine = G(e, pa, t.textDecorationLine ?? t.textDecoration), this.textShadow = G(e, $i, t.textShadow), this.textTransform = G(e, ea, t.textTransform), this.transform = G(e, ta, t.transform), this.transformOrigin = G(e, aa, t.transformOrigin), this.visibility = G(e, oa, t.visibility), this.webkitTextStrokeColor = G(e, Da, t.webkitTextStrokeColor), this.webkitTextStrokeWidth = G(e, Oa, t.webkitTextStrokeWidth), this.wordBreak = G(e, ca, t.wordBreak), this.zIndex = G(e, la, t.zIndex);
			}
			return e.prototype.isVisible = function() {
				return this.display > 0 && this.opacity > 0 && this.visibility === 0;
			}, e.prototype.isTransparent = function() {
				return vr(this.backgroundColor);
			}, e.prototype.isTransformed = function() {
				return this.transform !== null;
			}, e.prototype.isPositioned = function() {
				return this.position !== 0;
			}, e.prototype.isPositionedWithZIndex = function() {
				return this.isPositioned() && !this.zIndex.auto;
			}, e.prototype.isFloating = function() {
				return this.float !== 0;
			}, e.prototype.isInlineLevel = function() {
				return W(this.display, 4) || W(this.display, 33554432) || W(this.display, 268435456) || W(this.display, 536870912) || W(this.display, 67108864) || W(this.display, 134217728);
			}, e;
		}(), Aa = function() {
			function e(e, t) {
				this.content = G(e, ya, t.content), this.quotes = G(e, Ca, t.quotes);
			}
			return e;
		}(), ja = function() {
			function e(e, t) {
				this.counterIncrement = G(e, ba, t.counterIncrement), this.counterReset = G(e, xa, t.counterReset);
			}
			return e;
		}(), G = function(e, t, n) {
			var r = new Xn(), i = n == null ? t.initialValue : n.toString();
			r.write(i);
			var a = new Zn(r.read());
			switch (t.type) {
				case 2:
					var o = a.parseComponentValue();
					return t.parse(e, F(o) ? o.value : t.initialValue);
				case 0: return t.parse(e, a.parseComponentValue());
				case 1: return t.parse(e, a.parseComponentValues());
				case 4: return a.parseComponentValue();
				case 3:
					switch (t.format) {
						case "angle": return mr.parse(e, a.parseComponentValue());
						case "color": return _r.parse(e, a.parseComponentValue());
						case "image": return Yr.parse(e, a.parseComponentValue());
						case "length":
							var s = a.parseComponentValue();
							return ar(s) ? s : R;
						case "length-percentage":
							var c = a.parseComponentValue();
							return L(c) ? c : R;
						case "time": return ua.parse(e, a.parseComponentValue());
					}
					break;
			}
		}, Ma = "data-html2canvas-debug", Na = function(e) {
			switch (e.getAttribute(Ma)) {
				case "all": return 1;
				case "clone": return 2;
				case "parse": return 3;
				case "render": return 4;
				default: return 0;
			}
		}, Pa = function(e, t) {
			var n = Na(e);
			return n === 1 || t === n;
		}, K = function() {
			function e(e, t) {
				if (this.context = e, this.textNodes = [], this.elements = [], this.flags = 0, Pa(t, 3)) debugger;
				this.styles = new ka(e, window.getComputedStyle(t, null)), xs(t) && (this.styles.animationDuration.some(function(e) {
					return e > 0;
				}) && (t.style.animationDuration = "0s"), this.styles.transform !== null && (t.style.transform = "none")), this.bounds = s(this.context, t), Pa(t, 4) && (this.flags |= 16);
			}
			return e;
		}(), Fa = "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", Ia = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", La = typeof Uint8Array > "u" ? [] : new Uint8Array(256), Ra = 0; Ra < Ia.length; Ra++) La[Ia.charCodeAt(Ra)] = Ra;
		for (var za = function(e) {
			var t = e.length * .75, n = e.length, r, i = 0, a, o, s, c;
			e[e.length - 1] === "=" && (t--, e[e.length - 2] === "=" && t--);
			var l = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && Uint8Array.prototype.slice !== void 0 ? new ArrayBuffer(t) : Array(t), u = Array.isArray(l) ? l : new Uint8Array(l);
			for (r = 0; r < n; r += 4) a = La[e.charCodeAt(r)], o = La[e.charCodeAt(r + 1)], s = La[e.charCodeAt(r + 2)], c = La[e.charCodeAt(r + 3)], u[i++] = a << 2 | o >> 4, u[i++] = (o & 15) << 4 | s >> 2, u[i++] = (s & 3) << 6 | c & 63;
			return l;
		}, Ba = function(e) {
			for (var t = e.length, n = [], r = 0; r < t; r += 2) n.push(e[r + 1] << 8 | e[r]);
			return n;
		}, Va = function(e) {
			for (var t = e.length, n = [], r = 0; r < t; r += 4) n.push(e[r + 3] << 24 | e[r + 2] << 16 | e[r + 1] << 8 | e[r]);
			return n;
		}, Ha = 5, Ua = 11, Wa = 2, Ga = Ua - Ha, Ka = 65536 >> Ha, qa = (1 << Ha) - 1, Ja = Ka + (1024 >> Ha) + 32, Ya = 65536 >> Ua, Xa = (1 << Ga) - 1, Za = function(e, t, n) {
			return e.slice ? e.slice(t, n) : new Uint16Array(Array.prototype.slice.call(e, t, n));
		}, Qa = function(e, t, n) {
			return e.slice ? e.slice(t, n) : new Uint32Array(Array.prototype.slice.call(e, t, n));
		}, $a = function(e, t) {
			var n = za(e), r = Array.isArray(n) ? Va(n) : new Uint32Array(n), i = Array.isArray(n) ? Ba(n) : new Uint16Array(n), a = 24, o = Za(i, a / 2, r[4] / 2), s = r[5] === 2 ? Za(i, (a + r[4]) / 2) : Qa(r, Math.ceil((a + r[4]) / 4));
			return new eo(r[0], r[1], r[2], r[3], o, s);
		}, eo = function() {
			function e(e, t, n, r, i, a) {
				this.initialValue = e, this.errorValue = t, this.highStart = n, this.highValueIndex = r, this.index = i, this.data = a;
			}
			return e.prototype.get = function(e) {
				var t;
				if (e >= 0) {
					if (e < 55296 || e > 56319 && e <= 65535) return t = this.index[e >> Ha], t = (t << Wa) + (e & qa), this.data[t];
					if (e <= 65535) return t = this.index[Ka + (e - 55296 >> Ha)], t = (t << Wa) + (e & qa), this.data[t];
					if (e < this.highStart) return t = Ja - Ya + (e >> Ua), t = this.index[t], t += e >> Ha & Xa, t = this.index[t], t = (t << Wa) + (e & qa), this.data[t];
					if (e <= 1114111) return this.data[this.highValueIndex];
				}
				return this.errorValue;
			}, e;
		}(), to = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", no = typeof Uint8Array > "u" ? [] : new Uint8Array(256), ro = 0; ro < to.length; ro++) no[to.charCodeAt(ro)] = ro;
		var io = 1, ao = 2, oo = 3, so = 4, co = 5, lo = 7, uo = 8, fo = 9, po = 10, mo = 11, ho = 12, go = 13, _o = 14, vo = 15, yo = function(e) {
			for (var t = [], n = 0, r = e.length; n < r;) {
				var i = e.charCodeAt(n++);
				if (i >= 55296 && i <= 56319 && n < r) {
					var a = e.charCodeAt(n++);
					(a & 64512) == 56320 ? t.push(((i & 1023) << 10) + (a & 1023) + 65536) : (t.push(i), n--);
				} else t.push(i);
			}
			return t;
		}, bo = function() {
			var e = [...arguments];
			if (String.fromCodePoint) return String.fromCodePoint.apply(String, e);
			var t = e.length;
			if (!t) return "";
			for (var n = [], r = -1, i = ""; ++r < t;) {
				var a = e[r];
				a <= 65535 ? n.push(a) : (a -= 65536, n.push((a >> 10) + 55296, a % 1024 + 56320)), (r + 1 === t || n.length > 16384) && (i += String.fromCharCode.apply(String, n), n.length = 0);
			}
			return i;
		}, xo = $a(Fa), So = "×", Co = "÷", wo = function(e) {
			return xo.get(e);
		}, To = function(e, t, n) {
			var r = n - 2, i = t[r], a = t[n - 1], o = t[n];
			if (a === ao && o === oo) return So;
			if (a === ao || a === oo || a === so || o === ao || o === oo || o === so) return Co;
			if (a === uo && [
				uo,
				fo,
				mo,
				ho
			].indexOf(o) !== -1 || (a === mo || a === fo) && (o === fo || o === po) || (a === ho || a === po) && o === po || o === go || o === co || o === lo || a === io) return So;
			if (a === go && o === _o) {
				for (; i === co;) i = t[--r];
				if (i === _o) return So;
			}
			if (a === vo && o === vo) {
				for (var s = 0; i === vo;) s++, i = t[--r];
				if (s % 2 == 0) return So;
			}
			return Co;
		}, Eo = function(e) {
			var t = yo(e), n = t.length, r = 0, i = 0, a = t.map(wo);
			return { next: function() {
				if (r >= n) return {
					done: !0,
					value: null
				};
				for (var e = So; r < n && (e = To(t, a, ++r)) === So;);
				if (e !== So || r === n) {
					var o = bo.apply(null, t.slice(i, r));
					return i = r, {
						value: o,
						done: !1
					};
				}
				return {
					done: !0,
					value: null
				};
			} };
		}, Do = function(e) {
			for (var t = Eo(e), n = [], r; !(r = t.next()).done;) r.value && n.push(r.value.slice());
			return n;
		}, Oo = function(e) {
			var t = 123;
			if (e.createRange) {
				var n = e.createRange();
				if (n.getBoundingClientRect) {
					var r = e.createElement("boundtest");
					r.style.height = t + "px", r.style.display = "block", e.body.appendChild(r), n.selectNode(r);
					var i = n.getBoundingClientRect(), a = Math.round(i.height);
					if (e.body.removeChild(r), a === t) return !0;
				}
			}
			return !1;
		}, ko = function(e) {
			var t = e.createElement("boundtest");
			t.style.width = "50px", t.style.display = "block", t.style.fontSize = "12px", t.style.letterSpacing = "0px", t.style.wordSpacing = "0px", e.body.appendChild(t);
			var n = e.createRange();
			t.innerHTML = typeof "".repeat == "function" ? "&#128104;".repeat(10) : "";
			var r = t.firstChild, i = l(r.data).map(function(e) {
				return u(e);
			}), a = 0, o = {}, s = i.every(function(e, t) {
				n.setStart(r, a), n.setEnd(r, a + e.length);
				var i = n.getBoundingClientRect();
				a += e.length;
				var s = i.x > o.x || i.y > o.y;
				return o = i, t === 0 ? !0 : s;
			});
			return e.body.removeChild(t), s;
		}, Ao = function() {
			return new Image().crossOrigin !== void 0;
		}, jo = function() {
			return typeof new XMLHttpRequest().responseType == "string";
		}, Mo = function(e) {
			var t = new Image(), n = e.createElement("canvas"), r = n.getContext("2d");
			if (!r) return !1;
			t.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
			try {
				r.drawImage(t, 0, 0), n.toDataURL();
			} catch {
				return !1;
			}
			return !0;
		}, No = function(e) {
			return e[0] === 0 && e[1] === 255 && e[2] === 0 && e[3] === 255;
		}, Po = function(e) {
			var t = e.createElement("canvas"), n = 100;
			t.width = n, t.height = n;
			var r = t.getContext("2d");
			if (!r) return Promise.reject(!1);
			r.fillStyle = "rgb(0, 255, 0)", r.fillRect(0, 0, n, n);
			var i = new Image(), a = t.toDataURL();
			i.src = a;
			var o = Fo(n, n, 0, 0, i);
			return r.fillStyle = "red", r.fillRect(0, 0, n, n), Io(o).then(function(t) {
				r.drawImage(t, 0, 0);
				var i = r.getImageData(0, 0, n, n).data;
				r.fillStyle = "red", r.fillRect(0, 0, n, n);
				var o = e.createElement("div");
				return o.style.backgroundImage = "url(" + a + ")", o.style.height = n + "px", No(i) ? Io(Fo(n, n, 0, 0, o)) : Promise.reject(!1);
			}).then(function(e) {
				return r.drawImage(e, 0, 0), No(r.getImageData(0, 0, n, n).data);
			}).catch(function() {
				return !1;
			});
		}, Fo = function(e, t, n, r, i) {
			var a = "http://www.w3.org/2000/svg", o = document.createElementNS(a, "svg"), s = document.createElementNS(a, "foreignObject");
			return o.setAttributeNS(null, "width", e.toString()), o.setAttributeNS(null, "height", t.toString()), s.setAttributeNS(null, "width", "100%"), s.setAttributeNS(null, "height", "100%"), s.setAttributeNS(null, "x", n.toString()), s.setAttributeNS(null, "y", r.toString()), s.setAttributeNS(null, "externalResourcesRequired", "true"), o.appendChild(s), s.appendChild(i), o;
		}, Io = function(e) {
			return new Promise(function(t, n) {
				var r = new Image();
				r.onload = function() {
					return t(r);
				}, r.onerror = n, r.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(e));
			});
		}, q = {
			get SUPPORT_RANGE_BOUNDS() {
				var e = Oo(document);
				return Object.defineProperty(q, "SUPPORT_RANGE_BOUNDS", { value: e }), e;
			},
			get SUPPORT_WORD_BREAKING() {
				var e = q.SUPPORT_RANGE_BOUNDS && ko(document);
				return Object.defineProperty(q, "SUPPORT_WORD_BREAKING", { value: e }), e;
			},
			get SUPPORT_SVG_DRAWING() {
				var e = Mo(document);
				return Object.defineProperty(q, "SUPPORT_SVG_DRAWING", { value: e }), e;
			},
			get SUPPORT_FOREIGNOBJECT_DRAWING() {
				var e = typeof Array.from == "function" && typeof window.fetch == "function" ? Po(document) : Promise.resolve(!1);
				return Object.defineProperty(q, "SUPPORT_FOREIGNOBJECT_DRAWING", { value: e }), e;
			},
			get SUPPORT_CORS_IMAGES() {
				var e = Ao();
				return Object.defineProperty(q, "SUPPORT_CORS_IMAGES", { value: e }), e;
			},
			get SUPPORT_RESPONSE_TYPE() {
				var e = jo();
				return Object.defineProperty(q, "SUPPORT_RESPONSE_TYPE", { value: e }), e;
			},
			get SUPPORT_CORS_XHR() {
				var e = "withCredentials" in new XMLHttpRequest();
				return Object.defineProperty(q, "SUPPORT_CORS_XHR", { value: e }), e;
			},
			get SUPPORT_NATIVE_TEXT_SEGMENTATION() {
				var e = !!(typeof Intl < "u" && Intl.Segmenter);
				return Object.defineProperty(q, "SUPPORT_NATIVE_TEXT_SEGMENTATION", { value: e }), e;
			}
		}, Lo = function() {
			function e(e, t) {
				this.text = e, this.bounds = t;
			}
			return e;
		}(), Ro = function(e, t, n, r) {
			var i = Uo(t, n), a = [], s = 0;
			return i.forEach(function(t) {
				if (n.textDecorationLine.length || t.trim().length > 0) if (q.SUPPORT_RANGE_BOUNDS) {
					var i = Bo(r, s, t.length).getClientRects();
					if (i.length > 1) {
						var c = Vo(t), l = 0;
						c.forEach(function(t) {
							a.push(new Lo(t, o.fromDOMRectList(e, Bo(r, l + s, t.length).getClientRects()))), l += t.length;
						});
					} else a.push(new Lo(t, o.fromDOMRectList(e, i)));
				} else {
					var u = r.splitText(t.length);
					a.push(new Lo(t, zo(e, r))), r = u;
				}
				else q.SUPPORT_RANGE_BOUNDS || (r = r.splitText(t.length));
				s += t.length;
			}), a;
		}, zo = function(e, t) {
			var n = t.ownerDocument;
			if (n) {
				var r = n.createElement("html2canvaswrapper");
				r.appendChild(t.cloneNode(!0));
				var i = t.parentNode;
				if (i) {
					i.replaceChild(r, t);
					var a = s(e, r);
					return r.firstChild && i.replaceChild(r.firstChild, r), a;
				}
			}
			return o.EMPTY;
		}, Bo = function(e, t, n) {
			var r = e.ownerDocument;
			if (!r) throw Error("Node has no owner document");
			var i = r.createRange();
			return i.setStart(e, t), i.setEnd(e, t + n), i;
		}, Vo = function(e) {
			if (q.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
				var t = new Intl.Segmenter(void 0, { granularity: "grapheme" });
				return Array.from(t.segment(e)).map(function(e) {
					return e.segment;
				});
			}
			return Do(e);
		}, Ho = function(e, t) {
			if (q.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
				var n = new Intl.Segmenter(void 0, { granularity: "word" });
				return Array.from(n.segment(e)).map(function(e) {
					return e.segment;
				});
			}
			return Go(e, t);
		}, Uo = function(e, t) {
			return t.letterSpacing === 0 ? Ho(e, t) : Vo(e);
		}, Wo = [
			32,
			160,
			4961,
			65792,
			65793,
			4153,
			4241
		], Go = function(e, t) {
			for (var n = ft(e, {
				lineBreak: t.lineBreak,
				wordBreak: t.overflowWrap === "break-word" ? "break-word" : t.wordBreak
			}), r = [], i, a = function() {
				if (i.value) {
					var e = l(i.value.slice()), t = "";
					e.forEach(function(e) {
						Wo.indexOf(e) === -1 ? t += u(e) : (t.length && r.push(t), r.push(u(e)), t = "");
					}), t.length && r.push(t);
				}
			}; !(i = n.next()).done;) a();
			return r;
		}, Ko = function() {
			function e(e, t, n) {
				this.text = qo(t.data, n.textTransform), this.textBounds = Ro(e, this.text, n, t);
			}
			return e;
		}(), qo = function(e, t) {
			switch (t) {
				case 1: return e.toLowerCase();
				case 3: return e.replace(Jo, Yo);
				case 2: return e.toUpperCase();
				default: return e;
			}
		}, Jo = /(^|\s|:|-|\(|\))([a-z])/g, Yo = function(e, t, n) {
			return e.length > 0 ? t + n.toUpperCase() : e;
		}, Xo = function(e) {
			t(n, e);
			function n(t, n) {
				var r = e.call(this, t, n) || this;
				return r.src = n.currentSrc || n.src, r.intrinsicWidth = n.naturalWidth, r.intrinsicHeight = n.naturalHeight, r.context.cache.addImage(r.src), r;
			}
			return n;
		}(K), Zo = function(e) {
			t(n, e);
			function n(t, n) {
				var r = e.call(this, t, n) || this;
				return r.canvas = n, r.intrinsicWidth = n.width, r.intrinsicHeight = n.height, r;
			}
			return n;
		}(K), Qo = function(e) {
			t(n, e);
			function n(t, n) {
				var r = e.call(this, t, n) || this, i = new XMLSerializer(), a = s(t, n);
				return n.setAttribute("width", a.width + "px"), n.setAttribute("height", a.height + "px"), r.svg = "data:image/svg+xml," + encodeURIComponent(i.serializeToString(n)), r.intrinsicWidth = n.width.baseVal.value, r.intrinsicHeight = n.height.baseVal.value, r.context.cache.addImage(r.svg), r;
			}
			return n;
		}(K), $o = function(e) {
			t(n, e);
			function n(t, n) {
				var r = e.call(this, t, n) || this;
				return r.value = n.value, r;
			}
			return n;
		}(K), es = function(e) {
			t(n, e);
			function n(t, n) {
				var r = e.call(this, t, n) || this;
				return r.start = n.start, r.reversed = typeof n.reversed == "boolean" && n.reversed === !0, r;
			}
			return n;
		}(K), ts = [{
			type: 15,
			flags: 0,
			unit: "px",
			number: 3
		}], ns = [{
			type: 16,
			flags: 0,
			number: 50
		}], rs = function(e) {
			return e.width > e.height ? new o(e.left + (e.width - e.height) / 2, e.top, e.height, e.height) : e.width < e.height ? new o(e.left, e.top + (e.height - e.width) / 2, e.width, e.width) : e;
		}, is = function(e) {
			var t = e.type === ss ? Array(e.value.length + 1).join("•") : e.value;
			return t.length === 0 ? e.placeholder || "" : t;
		}, as = "checkbox", os = "radio", ss = "password", cs = 707406591, ls = function(e) {
			t(n, e);
			function n(t, n) {
				var r = e.call(this, t, n) || this;
				switch (r.type = n.type.toLowerCase(), r.checked = n.checked, r.value = is(n), (r.type === as || r.type === os) && (r.styles.backgroundColor = 3739148031, r.styles.borderTopColor = r.styles.borderRightColor = r.styles.borderBottomColor = r.styles.borderLeftColor = 2779096575, r.styles.borderTopWidth = r.styles.borderRightWidth = r.styles.borderBottomWidth = r.styles.borderLeftWidth = 1, r.styles.borderTopStyle = r.styles.borderRightStyle = r.styles.borderBottomStyle = r.styles.borderLeftStyle = 1, r.styles.backgroundClip = [0], r.styles.backgroundOrigin = [0], r.bounds = rs(r.bounds)), r.type) {
					case as:
						r.styles.borderTopRightRadius = r.styles.borderTopLeftRadius = r.styles.borderBottomRightRadius = r.styles.borderBottomLeftRadius = ts;
						break;
					case os:
						r.styles.borderTopRightRadius = r.styles.borderTopLeftRadius = r.styles.borderBottomRightRadius = r.styles.borderBottomLeftRadius = ns;
						break;
				}
				return r;
			}
			return n;
		}(K), us = function(e) {
			t(n, e);
			function n(t, n) {
				var r = e.call(this, t, n) || this, i = n.options[n.selectedIndex || 0];
				return r.value = i && i.text || "", r;
			}
			return n;
		}(K), ds = function(e) {
			t(n, e);
			function n(t, n) {
				var r = e.call(this, t, n) || this;
				return r.value = n.value, r;
			}
			return n;
		}(K), fs = function(e) {
			t(n, e);
			function n(t, n) {
				var r = e.call(this, t, n) || this;
				r.src = n.src, r.width = parseInt(n.width, 10) || 0, r.height = parseInt(n.height, 10) || 0, r.backgroundColor = r.styles.backgroundColor;
				try {
					if (n.contentWindow && n.contentWindow.document && n.contentWindow.document.documentElement) {
						r.tree = gs(t, n.contentWindow.document.documentElement);
						var i = n.contentWindow.document.documentElement ? Tr(t, getComputedStyle(n.contentWindow.document.documentElement).backgroundColor) : H.TRANSPARENT, a = n.contentWindow.document.body ? Tr(t, getComputedStyle(n.contentWindow.document.body).backgroundColor) : H.TRANSPARENT;
						r.backgroundColor = vr(i) ? vr(a) ? r.styles.backgroundColor : a : i;
					}
				} catch {}
				return r;
			}
			return n;
		}(K), ps = [
			"OL",
			"UL",
			"MENU"
		], ms = function(e, t, n, r) {
			for (var i = t.firstChild, a = void 0; i; i = a) if (a = i.nextSibling, ys(i) && i.data.trim().length > 0) n.textNodes.push(new Ko(e, i, n.styles));
			else if (bs(i)) if (Ls(i) && i.assignedNodes) i.assignedNodes().forEach(function(t) {
				return ms(e, t, n, r);
			});
			else {
				var o = hs(e, i);
				o.styles.isVisible() && (_s(i, o, r) ? o.flags |= 4 : vs(o.styles) && (o.flags |= 2), ps.indexOf(i.tagName) !== -1 && (o.flags |= 8), n.elements.push(o), i.slot, i.shadowRoot ? ms(e, i.shadowRoot, o, r) : !Fs(i) && !Ds(i) && !Is(i) && ms(e, i, o, r));
			}
		}, hs = function(e, t) {
			return js(t) ? new Xo(e, t) : ks(t) ? new Zo(e, t) : Ds(t) ? new Qo(e, t) : Cs(t) ? new $o(e, t) : ws(t) ? new es(e, t) : Ts(t) ? new ls(e, t) : Is(t) ? new us(e, t) : Fs(t) ? new ds(e, t) : Ms(t) ? new fs(e, t) : new K(e, t);
		}, gs = function(e, t) {
			var n = hs(e, t);
			return n.flags |= 4, ms(e, t, n, n), n;
		}, _s = function(e, t, n) {
			return t.styles.isPositionedWithZIndex() || t.styles.opacity < 1 || t.styles.isTransformed() || Os(e) && n.styles.isTransparent();
		}, vs = function(e) {
			return e.isPositioned() || e.isFloating();
		}, ys = function(e) {
			return e.nodeType === Node.TEXT_NODE;
		}, bs = function(e) {
			return e.nodeType === Node.ELEMENT_NODE;
		}, xs = function(e) {
			return bs(e) && e.style !== void 0 && !Ss(e);
		}, Ss = function(e) {
			return typeof e.className == "object";
		}, Cs = function(e) {
			return e.tagName === "LI";
		}, ws = function(e) {
			return e.tagName === "OL";
		}, Ts = function(e) {
			return e.tagName === "INPUT";
		}, Es = function(e) {
			return e.tagName === "HTML";
		}, Ds = function(e) {
			return e.tagName === "svg";
		}, Os = function(e) {
			return e.tagName === "BODY";
		}, ks = function(e) {
			return e.tagName === "CANVAS";
		}, As = function(e) {
			return e.tagName === "VIDEO";
		}, js = function(e) {
			return e.tagName === "IMG";
		}, Ms = function(e) {
			return e.tagName === "IFRAME";
		}, Ns = function(e) {
			return e.tagName === "STYLE";
		}, Ps = function(e) {
			return e.tagName === "SCRIPT";
		}, Fs = function(e) {
			return e.tagName === "TEXTAREA";
		}, Is = function(e) {
			return e.tagName === "SELECT";
		}, Ls = function(e) {
			return e.tagName === "SLOT";
		}, Rs = function(e) {
			return e.tagName.indexOf("-") > 0;
		}, zs = function() {
			function e() {
				this.counters = {};
			}
			return e.prototype.getCounterValue = function(e) {
				var t = this.counters[e];
				return t && t.length ? t[t.length - 1] : 1;
			}, e.prototype.getCounterValues = function(e) {
				return this.counters[e] || [];
			}, e.prototype.pop = function(e) {
				var t = this;
				e.forEach(function(e) {
					return t.counters[e].pop();
				});
			}, e.prototype.parse = function(e) {
				var t = this, n = e.counterIncrement, r = e.counterReset, i = !0;
				n !== null && n.forEach(function(e) {
					var n = t.counters[e.counter];
					n && e.increment !== 0 && (i = !1, n.length || n.push(1), n[Math.max(0, n.length - 1)] += e.increment);
				});
				var a = [];
				return i && r.forEach(function(e) {
					var n = t.counters[e.counter];
					a.push(e.counter), n ||= t.counters[e.counter] = [], n.push(e.reset);
				}), a;
			}, e;
		}(), Bs = {
			integers: [
				1e3,
				900,
				500,
				400,
				100,
				90,
				50,
				40,
				10,
				9,
				5,
				4,
				1
			],
			values: [
				"M",
				"CM",
				"D",
				"CD",
				"C",
				"XC",
				"L",
				"XL",
				"X",
				"IX",
				"V",
				"IV",
				"I"
			]
		}, Vs = {
			integers: [
				9e3,
				8e3,
				7e3,
				6e3,
				5e3,
				4e3,
				3e3,
				2e3,
				1e3,
				900,
				800,
				700,
				600,
				500,
				400,
				300,
				200,
				100,
				90,
				80,
				70,
				60,
				50,
				40,
				30,
				20,
				10,
				9,
				8,
				7,
				6,
				5,
				4,
				3,
				2,
				1
			],
			values: /* @__PURE__ */ "Ք.Փ.Ւ.Ց.Ր.Տ.Վ.Ս.Ռ.Ջ.Պ.Չ.Ո.Շ.Ն.Յ.Մ.Ճ.Ղ.Ձ.Հ.Կ.Ծ.Խ.Լ.Ի.Ժ.Թ.Ը.Է.Զ.Ե.Դ.Գ.Բ.Ա".split(".")
		}, Hs = {
			integers: [
				1e4,
				9e3,
				8e3,
				7e3,
				6e3,
				5e3,
				4e3,
				3e3,
				2e3,
				1e3,
				400,
				300,
				200,
				100,
				90,
				80,
				70,
				60,
				50,
				40,
				30,
				20,
				19,
				18,
				17,
				16,
				15,
				10,
				9,
				8,
				7,
				6,
				5,
				4,
				3,
				2,
				1
			],
			values: /* @__PURE__ */ "י׳.ט׳.ח׳.ז׳.ו׳.ה׳.ד׳.ג׳.ב׳.א׳.ת.ש.ר.ק.צ.פ.ע.ס.נ.מ.ל.כ.יט.יח.יז.טז.טו.י.ט.ח.ז.ו.ה.ד.ג.ב.א".split(".")
		}, Us = {
			integers: [
				1e4,
				9e3,
				8e3,
				7e3,
				6e3,
				5e3,
				4e3,
				3e3,
				2e3,
				1e3,
				900,
				800,
				700,
				600,
				500,
				400,
				300,
				200,
				100,
				90,
				80,
				70,
				60,
				50,
				40,
				30,
				20,
				10,
				9,
				8,
				7,
				6,
				5,
				4,
				3,
				2,
				1
			],
			values: /* @__PURE__ */ "ჵ.ჰ.ჯ.ჴ.ხ.ჭ.წ.ძ.ც.ჩ.შ.ყ.ღ.ქ.ფ.ჳ.ტ.ს.რ.ჟ.პ.ო.ჲ.ნ.მ.ლ.კ.ი.თ.ჱ.ზ.ვ.ე.დ.გ.ბ.ა".split(".")
		}, Ws = function(e, t, n, r, i, a) {
			return e < t || e > n ? nc(e, i, a.length > 0) : r.integers.reduce(function(t, n, i) {
				for (; e >= n;) e -= n, t += r.values[i];
				return t;
			}, "") + a;
		}, Gs = function(e, t, n, r) {
			var i = "";
			do
				n || e--, i = r(e) + i, e /= t;
			while (e * t >= t);
			return i;
		}, J = function(e, t, n, r, i) {
			var a = n - t + 1;
			return (e < 0 ? "-" : "") + (Gs(Math.abs(e), a, r, function(e) {
				return u(Math.floor(e % a) + t);
			}) + i);
		}, Ks = function(e, t, n) {
			n === void 0 && (n = ". ");
			var r = t.length;
			return Gs(Math.abs(e), r, !1, function(e) {
				return t[Math.floor(e % r)];
			}) + n;
		}, qs = 1, Js = 2, Ys = 4, Xs = 8, Zs = function(e, t, n, r, i, a) {
			if (e < -9999 || e > 9999) return nc(e, 4, i.length > 0);
			var o = Math.abs(e), s = i;
			if (o === 0) return t[0] + s;
			for (var c = 0; o > 0 && c <= 4; c++) {
				var l = o % 10;
				l === 0 && W(a, qs) && s !== "" ? s = t[l] + s : l > 1 || l === 1 && c === 0 || l === 1 && c === 1 && W(a, Js) || l === 1 && c === 1 && W(a, Ys) && e > 100 || l === 1 && c > 1 && W(a, Xs) ? s = t[l] + (c > 0 ? n[c - 1] : "") + s : l === 1 && c > 0 && (s = n[c - 1] + s), o = Math.floor(o / 10);
			}
			return (e < 0 ? r : "") + s;
		}, Qs = "十百千萬", $s = "拾佰仟萬", ec = "マイナス", tc = "마이너스", nc = function(e, t, n) {
			var r = n ? ". " : "", i = n ? "、" : "", a = n ? ", " : "", o = n ? " " : "";
			switch (t) {
				case 0: return "•" + o;
				case 1: return "◦" + o;
				case 2: return "◾" + o;
				case 5:
					var s = J(e, 48, 57, !0, r);
					return s.length < 4 ? "0" + s : s;
				case 4: return Ks(e, "〇一二三四五六七八九", i);
				case 6: return Ws(e, 1, 3999, Bs, 3, r).toLowerCase();
				case 7: return Ws(e, 1, 3999, Bs, 3, r);
				case 8: return J(e, 945, 969, !1, r);
				case 9: return J(e, 97, 122, !1, r);
				case 10: return J(e, 65, 90, !1, r);
				case 11: return J(e, 1632, 1641, !0, r);
				case 12:
				case 49: return Ws(e, 1, 9999, Vs, 3, r);
				case 35: return Ws(e, 1, 9999, Vs, 3, r).toLowerCase();
				case 13: return J(e, 2534, 2543, !0, r);
				case 14:
				case 30: return J(e, 6112, 6121, !0, r);
				case 15: return Ks(e, "子丑寅卯辰巳午未申酉戌亥", i);
				case 16: return Ks(e, "甲乙丙丁戊己庚辛壬癸", i);
				case 17:
				case 48: return Zs(e, "零一二三四五六七八九", Qs, "負", i, Js | Ys | Xs);
				case 47: return Zs(e, "零壹貳參肆伍陸柒捌玖", $s, "負", i, qs | Js | Ys | Xs);
				case 42: return Zs(e, "零一二三四五六七八九", Qs, "负", i, Js | Ys | Xs);
				case 41: return Zs(e, "零壹贰叁肆伍陆柒捌玖", $s, "负", i, qs | Js | Ys | Xs);
				case 26: return Zs(e, "〇一二三四五六七八九", "十百千万", ec, i, 0);
				case 25: return Zs(e, "零壱弐参四伍六七八九", "拾百千万", ec, i, qs | Js | Ys);
				case 31: return Zs(e, "영일이삼사오육칠팔구", "십백천만", tc, a, qs | Js | Ys);
				case 33: return Zs(e, "零一二三四五六七八九", "十百千萬", tc, a, 0);
				case 32: return Zs(e, "零壹貳參四五六七八九", "拾百千", tc, a, qs | Js | Ys);
				case 18: return J(e, 2406, 2415, !0, r);
				case 20: return Ws(e, 1, 19999, Us, 3, r);
				case 21: return J(e, 2790, 2799, !0, r);
				case 22: return J(e, 2662, 2671, !0, r);
				case 22: return Ws(e, 1, 10999, Hs, 3, r);
				case 23: return Ks(e, "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん");
				case 24: return Ks(e, "いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす");
				case 27: return J(e, 3302, 3311, !0, r);
				case 28: return Ks(e, "アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン", i);
				case 29: return Ks(e, "イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス", i);
				case 34: return J(e, 3792, 3801, !0, r);
				case 37: return J(e, 6160, 6169, !0, r);
				case 38: return J(e, 4160, 4169, !0, r);
				case 39: return J(e, 2918, 2927, !0, r);
				case 40: return J(e, 1776, 1785, !0, r);
				case 43: return J(e, 3046, 3055, !0, r);
				case 44: return J(e, 3174, 3183, !0, r);
				case 45: return J(e, 3664, 3673, !0, r);
				case 46: return J(e, 3872, 3881, !0, r);
				default: return J(e, 48, 57, !0, r);
			}
		}, rc = "data-html2canvas-ignore", ic = function() {
			function e(e, t, n) {
				if (this.context = e, this.options = n, this.scrolledElements = [], this.referenceElement = t, this.counters = new zs(), this.quoteDepth = 0, !t.ownerDocument) throw Error("Cloned element does not have an owner document");
				this.documentElement = this.cloneNode(t.ownerDocument.documentElement, !1);
			}
			return e.prototype.toIFrame = function(e, t) {
				var n = this, a = oc(e, t);
				if (!a.contentWindow) return Promise.reject("Unable to find iframe window");
				var o = e.defaultView.pageXOffset, s = e.defaultView.pageYOffset, c = a.contentWindow, l = c.document, u = lc(a).then(function() {
					return r(n, void 0, void 0, function() {
						var e, n;
						return i(this, function(r) {
							switch (r.label) {
								case 0: return this.scrolledElements.forEach(mc), c && (c.scrollTo(t.left, t.top), /(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (c.scrollY !== t.top || c.scrollX !== t.left) && (this.context.logger.warn("Unable to restore scroll position for cloned document"), this.context.windowBounds = this.context.windowBounds.add(c.scrollX - t.left, c.scrollY - t.top, 0, 0))), e = this.options.onclone, n = this.clonedReferenceElement, n === void 0 ? [2, Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")] : l.fonts && l.fonts.ready ? [4, l.fonts.ready] : [3, 2];
								case 1: r.sent(), r.label = 2;
								case 2: return /(AppleWebKit)/g.test(navigator.userAgent) ? [4, cc(l)] : [3, 4];
								case 3: r.sent(), r.label = 4;
								case 4: return typeof e == "function" ? [2, Promise.resolve().then(function() {
									return e(l, n);
								}).then(function() {
									return a;
								})] : [2, a];
							}
						});
					});
				});
				return l.open(), l.write(fc(document.doctype) + "<html></html>"), pc(this.referenceElement.ownerDocument, o, s), l.replaceChild(l.adoptNode(this.documentElement), l.documentElement), l.close(), u;
			}, e.prototype.createElementClone = function(e) {
				if (Pa(e, 2)) debugger;
				if (ks(e)) return this.createCanvasClone(e);
				if (As(e)) return this.createVideoClone(e);
				if (Ns(e)) return this.createStyleClone(e);
				var t = e.cloneNode(!1);
				return js(t) && (js(e) && e.currentSrc && e.currentSrc !== e.src && (t.src = e.currentSrc, t.srcset = ""), t.loading === "lazy" && (t.loading = "eager")), Rs(t) ? this.createCustomElementClone(t) : t;
			}, e.prototype.createCustomElementClone = function(e) {
				var t = document.createElement("html2canvascustomelement");
				return dc(e.style, t), t;
			}, e.prototype.createStyleClone = function(e) {
				try {
					var t = e.sheet;
					if (t && t.cssRules) {
						var n = [].slice.call(t.cssRules, 0).reduce(function(e, t) {
							return t && typeof t.cssText == "string" ? e + t.cssText : e;
						}, ""), r = e.cloneNode(!1);
						return r.textContent = n, r;
					}
				} catch (e) {
					if (this.context.logger.error("Unable to access cssRules property", e), e.name !== "SecurityError") throw e;
				}
				return e.cloneNode(!1);
			}, e.prototype.createCanvasClone = function(e) {
				if (this.options.inlineImages && e.ownerDocument) {
					var t = e.ownerDocument.createElement("img");
					try {
						return t.src = e.toDataURL(), t;
					} catch {
						this.context.logger.info("Unable to inline canvas contents, canvas is tainted", e);
					}
				}
				var n = e.cloneNode(!1);
				try {
					n.width = e.width, n.height = e.height;
					var r = e.getContext("2d"), i = n.getContext("2d");
					if (i) if (!this.options.allowTaint && r) i.putImageData(r.getImageData(0, 0, e.width, e.height), 0, 0);
					else {
						var a = e.getContext("webgl2") ?? e.getContext("webgl");
						a && a.getContextAttributes()?.preserveDrawingBuffer === !1 && this.context.logger.warn("Unable to clone WebGL context as it has preserveDrawingBuffer=false", e), i.drawImage(e, 0, 0);
					}
					return n;
				} catch {
					this.context.logger.info("Unable to clone canvas as it is tainted", e);
				}
				return n;
			}, e.prototype.createVideoClone = function(e) {
				var t = e.ownerDocument.createElement("canvas");
				t.width = e.offsetWidth, t.height = e.offsetHeight;
				var n = t.getContext("2d");
				try {
					return n && (n.drawImage(e, 0, 0, t.width, t.height), this.options.allowTaint || n.getImageData(0, 0, t.width, t.height)), t;
				} catch {
					this.context.logger.info("Unable to clone video as it is tainted", e);
				}
				var r = e.ownerDocument.createElement("canvas");
				return r.width = e.offsetWidth, r.height = e.offsetHeight, r;
			}, e.prototype.appendChildNode = function(e, t, n) {
				(!bs(t) || !Ps(t) && !t.hasAttribute(rc) && (typeof this.options.ignoreElements != "function" || !this.options.ignoreElements(t))) && (!this.options.copyStyles || !bs(t) || !Ns(t)) && e.appendChild(this.cloneNode(t, n));
			}, e.prototype.cloneChildNodes = function(e, t, n) {
				for (var r = this, i = e.shadowRoot ? e.shadowRoot.firstChild : e.firstChild; i; i = i.nextSibling) if (bs(i) && Ls(i) && typeof i.assignedNodes == "function") {
					var a = i.assignedNodes();
					a.length && a.forEach(function(e) {
						return r.appendChildNode(t, e, n);
					});
				} else this.appendChildNode(t, i, n);
			}, e.prototype.cloneNode = function(e, t) {
				if (ys(e)) return document.createTextNode(e.data);
				if (!e.ownerDocument) return e.cloneNode(!1);
				var n = e.ownerDocument.defaultView;
				if (n && bs(e) && (xs(e) || Ss(e))) {
					var r = this.createElementClone(e);
					r.style.transitionProperty = "none";
					var i = n.getComputedStyle(e), a = n.getComputedStyle(e, ":before"), o = n.getComputedStyle(e, ":after");
					this.referenceElement === e && xs(r) && (this.clonedReferenceElement = r), Os(r) && bc(r);
					var s = this.counters.parse(new ja(this.context, i)), c = this.resolvePseudoContent(e, r, a, ac.BEFORE);
					Rs(e) && (t = !0), As(e) || this.cloneChildNodes(e, r, t), c && r.insertBefore(c, r.firstChild);
					var l = this.resolvePseudoContent(e, r, o, ac.AFTER);
					return l && r.appendChild(l), this.counters.pop(s), (i && (this.options.copyStyles || Ss(e)) && !Ms(e) || t) && dc(i, r), (e.scrollTop !== 0 || e.scrollLeft !== 0) && this.scrolledElements.push([
						r,
						e.scrollLeft,
						e.scrollTop
					]), (Fs(e) || Is(e)) && (Fs(r) || Is(r)) && (r.value = e.value), r;
				}
				return e.cloneNode(!1);
			}, e.prototype.resolvePseudoContent = function(e, t, n, r) {
				var i = this;
				if (n) {
					var a = n.content, o = t.ownerDocument;
					if (!(!o || !a || a === "none" || a === "-moz-alt-content" || n.display === "none")) {
						this.counters.parse(new ja(this.context, n));
						var s = new Aa(this.context, n), c = o.createElement("html2canvaspseudoelement");
						dc(n, c), s.content.forEach(function(t) {
							if (t.type === 0) c.appendChild(o.createTextNode(t.value));
							else if (t.type === 22) {
								var n = o.createElement("img");
								n.src = t.value, n.style.opacity = "1", c.appendChild(n);
							} else if (t.type === 18) {
								if (t.name === "attr") {
									var r = t.values.filter(F);
									r.length && c.appendChild(o.createTextNode(e.getAttribute(r[0].value) || ""));
								} else if (t.name === "counter") {
									var a = t.values.filter(rr), l = a[0], u = a[1];
									if (l && F(l)) {
										var d = i.counters.getCounterValue(l.value), f = u && F(u) ? Ri.parse(i.context, u.value) : 3;
										c.appendChild(o.createTextNode(nc(d, f, !1)));
									}
								} else if (t.name === "counters") {
									var p = t.values.filter(rr), l = p[0], m = p[1], u = p[2];
									if (l && F(l)) {
										var h = i.counters.getCounterValues(l.value), g = u && F(u) ? Ri.parse(i.context, u.value) : 3, _ = m && m.type === 0 ? m.value : "", v = h.map(function(e) {
											return nc(e, g, !1);
										}).join(_);
										c.appendChild(o.createTextNode(v));
									}
								}
							} else if (t.type === 20) switch (t.value) {
								case "open-quote":
									c.appendChild(o.createTextNode(wa(s.quotes, i.quoteDepth++, !0)));
									break;
								case "close-quote":
									c.appendChild(o.createTextNode(wa(s.quotes, --i.quoteDepth, !1)));
									break;
								default: c.appendChild(o.createTextNode(t.value));
							}
						}), c.className = _c + " " + vc;
						var l = r === ac.BEFORE ? " " + _c : " " + vc;
						return Ss(t) ? t.className.baseValue += l : t.className += l, c;
					}
				}
			}, e.destroy = function(e) {
				return e.parentNode ? (e.parentNode.removeChild(e), !0) : !1;
			}, e;
		}(), ac;
		(function(e) {
			e[e.BEFORE = 0] = "BEFORE", e[e.AFTER = 1] = "AFTER";
		})(ac ||= {});
		var oc = function(e, t) {
			var n = e.createElement("iframe");
			return n.className = "html2canvas-container", n.style.visibility = "hidden", n.style.position = "fixed", n.style.left = "-10000px", n.style.top = "0px", n.style.border = "0", n.width = t.width.toString(), n.height = t.height.toString(), n.scrolling = "no", n.setAttribute(rc, "true"), e.body.appendChild(n), n;
		}, sc = function(e) {
			return new Promise(function(t) {
				if (e.complete) {
					t();
					return;
				}
				if (!e.src) {
					t();
					return;
				}
				e.onload = t, e.onerror = t;
			});
		}, cc = function(e) {
			return Promise.all([].slice.call(e.images, 0).map(sc));
		}, lc = function(e) {
			return new Promise(function(t, n) {
				var r = e.contentWindow;
				if (!r) return n("No window assigned for iframe");
				var i = r.document;
				r.onload = e.onload = function() {
					r.onload = e.onload = null;
					var n = setInterval(function() {
						i.body.childNodes.length > 0 && i.readyState === "complete" && (clearInterval(n), t(e));
					}, 50);
				};
			});
		}, uc = [
			"all",
			"d",
			"content"
		], dc = function(e, t) {
			for (var n = e.length - 1; n >= 0; n--) {
				var r = e.item(n);
				uc.indexOf(r) === -1 && t.style.setProperty(r, e.getPropertyValue(r));
			}
			return t;
		}, fc = function(e) {
			var t = "";
			return e && (t += "<!DOCTYPE ", e.name && (t += e.name), e.internalSubset && (t += e.internalSubset), e.publicId && (t += "\"" + e.publicId + "\""), e.systemId && (t += "\"" + e.systemId + "\""), t += ">"), t;
		}, pc = function(e, t, n) {
			e && e.defaultView && (t !== e.defaultView.pageXOffset || n !== e.defaultView.pageYOffset) && e.defaultView.scrollTo(t, n);
		}, mc = function(e) {
			var t = e[0], n = e[1], r = e[2];
			t.scrollLeft = n, t.scrollTop = r;
		}, hc = ":before", gc = ":after", _c = "___html2canvas___pseudoelement_before", vc = "___html2canvas___pseudoelement_after", yc = "{\n    content: \"\" !important;\n    display: none !important;\n}", bc = function(e) {
			xc(e, "." + _c + hc + yc + "\n         ." + vc + gc + yc);
		}, xc = function(e, t) {
			var n = e.ownerDocument;
			if (n) {
				var r = n.createElement("style");
				r.textContent = t, e.appendChild(r);
			}
		}, Sc = function() {
			function e() {}
			return e.getOrigin = function(t) {
				var n = e._link;
				return n ? (n.href = t, n.href = n.href, n.protocol + n.hostname + n.port) : "about:blank";
			}, e.isSameOrigin = function(t) {
				return e.getOrigin(t) === e._origin;
			}, e.setContext = function(t) {
				e._link = t.document.createElement("a"), e._origin = e.getOrigin(t.location.href);
			}, e._origin = "about:blank", e;
		}(), Cc = function() {
			function e(e, t) {
				this.context = e, this._options = t, this._cache = {};
			}
			return e.prototype.addImage = function(e) {
				var t = Promise.resolve();
				return this.has(e) || (Ac(e) || Dc(e)) && (this._cache[e] = this.loadImage(e)).catch(function() {}), t;
			}, e.prototype.match = function(e) {
				return this._cache[e];
			}, e.prototype.loadImage = function(e) {
				return r(this, void 0, void 0, function() {
					var t, n, r, a, o = this;
					return i(this, function(i) {
						switch (i.label) {
							case 0: return t = Sc.isSameOrigin(e), n = !Oc(e) && this._options.useCORS === !0 && q.SUPPORT_CORS_IMAGES && !t, r = !Oc(e) && !t && !Ac(e) && typeof this._options.proxy == "string" && q.SUPPORT_CORS_XHR && !n, !t && this._options.allowTaint === !1 && !Oc(e) && !Ac(e) && !r && !n ? [2] : (a = e, r ? [4, this.proxy(a)] : [3, 2]);
							case 1: a = i.sent(), i.label = 2;
							case 2: return this.context.logger.debug("Added image " + e.substring(0, 256)), [4, new Promise(function(e, t) {
								var r = new Image();
								r.onload = function() {
									return e(r);
								}, r.onerror = t, (kc(a) || n) && (r.crossOrigin = "anonymous"), r.src = a, r.complete === !0 && setTimeout(function() {
									return e(r);
								}, 500), o._options.imageTimeout > 0 && setTimeout(function() {
									return t("Timed out (" + o._options.imageTimeout + "ms) loading image");
								}, o._options.imageTimeout);
							})];
							case 3: return [2, i.sent()];
						}
					});
				});
			}, e.prototype.has = function(e) {
				return this._cache[e] !== void 0;
			}, e.prototype.keys = function() {
				return Promise.resolve(Object.keys(this._cache));
			}, e.prototype.proxy = function(e) {
				var t = this, n = this._options.proxy;
				if (!n) throw Error("No proxy defined");
				var r = e.substring(0, 256);
				return new Promise(function(i, a) {
					var o = q.SUPPORT_RESPONSE_TYPE ? "blob" : "text", s = new XMLHttpRequest();
					s.onload = function() {
						if (s.status === 200) if (o === "text") i(s.response);
						else {
							var e = new FileReader();
							e.addEventListener("load", function() {
								return i(e.result);
							}, !1), e.addEventListener("error", function(e) {
								return a(e);
							}, !1), e.readAsDataURL(s.response);
						}
						else a("Failed to proxy resource " + r + " with status code " + s.status);
					}, s.onerror = a;
					var c = n.indexOf("?") > -1 ? "&" : "?";
					if (s.open("GET", "" + n + c + "url=" + encodeURIComponent(e) + "&responseType=" + o), o !== "text" && s instanceof XMLHttpRequest && (s.responseType = o), t._options.imageTimeout) {
						var l = t._options.imageTimeout;
						s.timeout = l, s.ontimeout = function() {
							return a("Timed out (" + l + "ms) proxying " + r);
						};
					}
					s.send();
				});
			}, e;
		}(), wc = /^data:image\/svg\+xml/i, Tc = /^data:image\/.*;base64,/i, Ec = /^data:image\/.*/i, Dc = function(e) {
			return q.SUPPORT_SVG_DRAWING || !jc(e);
		}, Oc = function(e) {
			return Ec.test(e);
		}, kc = function(e) {
			return Tc.test(e);
		}, Ac = function(e) {
			return e.substr(0, 4) === "blob";
		}, jc = function(e) {
			return e.substr(-3).toLowerCase() === "svg" || wc.test(e);
		}, Y = function() {
			function e(e, t) {
				this.type = 0, this.x = e, this.y = t;
			}
			return e.prototype.add = function(t, n) {
				return new e(this.x + t, this.y + n);
			}, e;
		}(), Mc = function(e, t, n) {
			return new Y(e.x + (t.x - e.x) * n, e.y + (t.y - e.y) * n);
		}, Nc = function() {
			function e(e, t, n, r) {
				this.type = 1, this.start = e, this.startControl = t, this.endControl = n, this.end = r;
			}
			return e.prototype.subdivide = function(t, n) {
				var r = Mc(this.start, this.startControl, t), i = Mc(this.startControl, this.endControl, t), a = Mc(this.endControl, this.end, t), o = Mc(r, i, t), s = Mc(i, a, t), c = Mc(o, s, t);
				return n ? new e(this.start, r, o, c) : new e(c, s, a, this.end);
			}, e.prototype.add = function(t, n) {
				return new e(this.start.add(t, n), this.startControl.add(t, n), this.endControl.add(t, n), this.end.add(t, n));
			}, e.prototype.reverse = function() {
				return new e(this.end, this.endControl, this.startControl, this.start);
			}, e;
		}(), X = function(e) {
			return e.type === 1;
		}, Pc = function() {
			function e(e) {
				var t = e.styles, n = e.bounds, r = lr(t.borderTopLeftRadius, n.width, n.height), i = r[0], a = r[1], o = lr(t.borderTopRightRadius, n.width, n.height), s = o[0], c = o[1], l = lr(t.borderBottomRightRadius, n.width, n.height), u = l[0], d = l[1], f = lr(t.borderBottomLeftRadius, n.width, n.height), p = f[0], m = f[1], h = [];
				h.push((i + s) / n.width), h.push((p + u) / n.width), h.push((a + m) / n.height), h.push((c + d) / n.height);
				var g = Math.max.apply(Math, h);
				g > 1 && (i /= g, a /= g, s /= g, c /= g, u /= g, d /= g, p /= g, m /= g);
				var _ = n.width - s, v = n.height - d, y = n.width - u, b = n.height - m, x = t.borderTopWidth, S = t.borderRightWidth, C = t.borderBottomWidth, w = t.borderLeftWidth, T = z(t.paddingTop, e.bounds.width), E = z(t.paddingRight, e.bounds.width), D = z(t.paddingBottom, e.bounds.width), O = z(t.paddingLeft, e.bounds.width);
				this.topLeftBorderDoubleOuterBox = i > 0 || a > 0 ? Q(n.left + w / 3, n.top + x / 3, i - w / 3, a - x / 3, Z.TOP_LEFT) : new Y(n.left + w / 3, n.top + x / 3), this.topRightBorderDoubleOuterBox = i > 0 || a > 0 ? Q(n.left + _, n.top + x / 3, s - S / 3, c - x / 3, Z.TOP_RIGHT) : new Y(n.left + n.width - S / 3, n.top + x / 3), this.bottomRightBorderDoubleOuterBox = u > 0 || d > 0 ? Q(n.left + y, n.top + v, u - S / 3, d - C / 3, Z.BOTTOM_RIGHT) : new Y(n.left + n.width - S / 3, n.top + n.height - C / 3), this.bottomLeftBorderDoubleOuterBox = p > 0 || m > 0 ? Q(n.left + w / 3, n.top + b, p - w / 3, m - C / 3, Z.BOTTOM_LEFT) : new Y(n.left + w / 3, n.top + n.height - C / 3), this.topLeftBorderDoubleInnerBox = i > 0 || a > 0 ? Q(n.left + w * 2 / 3, n.top + x * 2 / 3, i - w * 2 / 3, a - x * 2 / 3, Z.TOP_LEFT) : new Y(n.left + w * 2 / 3, n.top + x * 2 / 3), this.topRightBorderDoubleInnerBox = i > 0 || a > 0 ? Q(n.left + _, n.top + x * 2 / 3, s - S * 2 / 3, c - x * 2 / 3, Z.TOP_RIGHT) : new Y(n.left + n.width - S * 2 / 3, n.top + x * 2 / 3), this.bottomRightBorderDoubleInnerBox = u > 0 || d > 0 ? Q(n.left + y, n.top + v, u - S * 2 / 3, d - C * 2 / 3, Z.BOTTOM_RIGHT) : new Y(n.left + n.width - S * 2 / 3, n.top + n.height - C * 2 / 3), this.bottomLeftBorderDoubleInnerBox = p > 0 || m > 0 ? Q(n.left + w * 2 / 3, n.top + b, p - w * 2 / 3, m - C * 2 / 3, Z.BOTTOM_LEFT) : new Y(n.left + w * 2 / 3, n.top + n.height - C * 2 / 3), this.topLeftBorderStroke = i > 0 || a > 0 ? Q(n.left + w / 2, n.top + x / 2, i - w / 2, a - x / 2, Z.TOP_LEFT) : new Y(n.left + w / 2, n.top + x / 2), this.topRightBorderStroke = i > 0 || a > 0 ? Q(n.left + _, n.top + x / 2, s - S / 2, c - x / 2, Z.TOP_RIGHT) : new Y(n.left + n.width - S / 2, n.top + x / 2), this.bottomRightBorderStroke = u > 0 || d > 0 ? Q(n.left + y, n.top + v, u - S / 2, d - C / 2, Z.BOTTOM_RIGHT) : new Y(n.left + n.width - S / 2, n.top + n.height - C / 2), this.bottomLeftBorderStroke = p > 0 || m > 0 ? Q(n.left + w / 2, n.top + b, p - w / 2, m - C / 2, Z.BOTTOM_LEFT) : new Y(n.left + w / 2, n.top + n.height - C / 2), this.topLeftBorderBox = i > 0 || a > 0 ? Q(n.left, n.top, i, a, Z.TOP_LEFT) : new Y(n.left, n.top), this.topRightBorderBox = s > 0 || c > 0 ? Q(n.left + _, n.top, s, c, Z.TOP_RIGHT) : new Y(n.left + n.width, n.top), this.bottomRightBorderBox = u > 0 || d > 0 ? Q(n.left + y, n.top + v, u, d, Z.BOTTOM_RIGHT) : new Y(n.left + n.width, n.top + n.height), this.bottomLeftBorderBox = p > 0 || m > 0 ? Q(n.left, n.top + b, p, m, Z.BOTTOM_LEFT) : new Y(n.left, n.top + n.height), this.topLeftPaddingBox = i > 0 || a > 0 ? Q(n.left + w, n.top + x, Math.max(0, i - w), Math.max(0, a - x), Z.TOP_LEFT) : new Y(n.left + w, n.top + x), this.topRightPaddingBox = s > 0 || c > 0 ? Q(n.left + Math.min(_, n.width - S), n.top + x, _ > n.width + S ? 0 : Math.max(0, s - S), Math.max(0, c - x), Z.TOP_RIGHT) : new Y(n.left + n.width - S, n.top + x), this.bottomRightPaddingBox = u > 0 || d > 0 ? Q(n.left + Math.min(y, n.width - w), n.top + Math.min(v, n.height - C), Math.max(0, u - S), Math.max(0, d - C), Z.BOTTOM_RIGHT) : new Y(n.left + n.width - S, n.top + n.height - C), this.bottomLeftPaddingBox = p > 0 || m > 0 ? Q(n.left + w, n.top + Math.min(b, n.height - C), Math.max(0, p - w), Math.max(0, m - C), Z.BOTTOM_LEFT) : new Y(n.left + w, n.top + n.height - C), this.topLeftContentBox = i > 0 || a > 0 ? Q(n.left + w + O, n.top + x + T, Math.max(0, i - (w + O)), Math.max(0, a - (x + T)), Z.TOP_LEFT) : new Y(n.left + w + O, n.top + x + T), this.topRightContentBox = s > 0 || c > 0 ? Q(n.left + Math.min(_, n.width + w + O), n.top + x + T, _ > n.width + w + O ? 0 : s - w + O, c - (x + T), Z.TOP_RIGHT) : new Y(n.left + n.width - (S + E), n.top + x + T), this.bottomRightContentBox = u > 0 || d > 0 ? Q(n.left + Math.min(y, n.width - (w + O)), n.top + Math.min(v, n.height + x + T), Math.max(0, u - (S + E)), d - (C + D), Z.BOTTOM_RIGHT) : new Y(n.left + n.width - (S + E), n.top + n.height - (C + D)), this.bottomLeftContentBox = p > 0 || m > 0 ? Q(n.left + w + O, n.top + b, Math.max(0, p - (w + O)), m - (C + D), Z.BOTTOM_LEFT) : new Y(n.left + w + O, n.top + n.height - (C + D));
			}
			return e;
		}(), Z;
		(function(e) {
			e[e.TOP_LEFT = 0] = "TOP_LEFT", e[e.TOP_RIGHT = 1] = "TOP_RIGHT", e[e.BOTTOM_RIGHT = 2] = "BOTTOM_RIGHT", e[e.BOTTOM_LEFT = 3] = "BOTTOM_LEFT";
		})(Z ||= {});
		var Q = function(e, t, n, r, i) {
			var a = 4 * ((Math.sqrt(2) - 1) / 3), o = n * a, s = r * a, c = e + n, l = t + r;
			switch (i) {
				case Z.TOP_LEFT: return new Nc(new Y(e, l), new Y(e, l - s), new Y(c - o, t), new Y(c, t));
				case Z.TOP_RIGHT: return new Nc(new Y(e, t), new Y(e + o, t), new Y(c, l - s), new Y(c, l));
				case Z.BOTTOM_RIGHT: return new Nc(new Y(c, t), new Y(c, t + s), new Y(e + o, l), new Y(e, l));
				case Z.BOTTOM_LEFT:
				default: return new Nc(new Y(c, l), new Y(c - o, l), new Y(e, t + s), new Y(e, t));
			}
		}, Fc = function(e) {
			return [
				e.topLeftBorderBox,
				e.topRightBorderBox,
				e.bottomRightBorderBox,
				e.bottomLeftBorderBox
			];
		}, Ic = function(e) {
			return [
				e.topLeftContentBox,
				e.topRightContentBox,
				e.bottomRightContentBox,
				e.bottomLeftContentBox
			];
		}, Lc = function(e) {
			return [
				e.topLeftPaddingBox,
				e.topRightPaddingBox,
				e.bottomRightPaddingBox,
				e.bottomLeftPaddingBox
			];
		}, Rc = function() {
			function e(e, t, n) {
				this.offsetX = e, this.offsetY = t, this.matrix = n, this.type = 0, this.target = 6;
			}
			return e;
		}(), zc = function() {
			function e(e, t) {
				this.path = e, this.target = t, this.type = 1;
			}
			return e;
		}(), Bc = function() {
			function e(e) {
				this.opacity = e, this.type = 2, this.target = 6;
			}
			return e;
		}(), Vc = function(e) {
			return e.type === 0;
		}, Hc = function(e) {
			return e.type === 1;
		}, Uc = function(e) {
			return e.type === 2;
		}, Wc = function(e, t) {
			return e.length === t.length ? e.some(function(e, n) {
				return e === t[n];
			}) : !1;
		}, Gc = function(e, t, n, r, i) {
			return e.map(function(e, a) {
				switch (a) {
					case 0: return e.add(t, n);
					case 1: return e.add(t + r, n);
					case 2: return e.add(t + r, n + i);
					case 3: return e.add(t, n + i);
				}
				return e;
			});
		}, Kc = function() {
			function e(e) {
				this.element = e, this.inlineLevel = [], this.nonInlineLevel = [], this.negativeZIndex = [], this.zeroOrAutoZIndexOrTransformedOrOpacity = [], this.positiveZIndex = [], this.nonPositionedFloats = [], this.nonPositionedInlineLevel = [];
			}
			return e;
		}(), qc = function() {
			function e(e, t) {
				if (this.container = e, this.parent = t, this.effects = [], this.curves = new Pc(this.container), this.container.styles.opacity < 1 && this.effects.push(new Bc(this.container.styles.opacity)), this.container.styles.transform !== null) {
					var n = this.container.bounds.left + this.container.styles.transformOrigin[0].number, r = this.container.bounds.top + this.container.styles.transformOrigin[1].number, i = this.container.styles.transform;
					this.effects.push(new Rc(n, r, i));
				}
				if (this.container.styles.overflowX !== 0) {
					var a = Fc(this.curves), o = Lc(this.curves);
					Wc(a, o) ? this.effects.push(new zc(a, 6)) : (this.effects.push(new zc(a, 2)), this.effects.push(new zc(o, 4)));
				}
			}
			return e.prototype.getEffects = function(e) {
				for (var t = [2, 3].indexOf(this.container.styles.position) === -1, n = this.parent, r = this.effects.slice(0); n;) {
					var i = n.effects.filter(function(e) {
						return !Hc(e);
					});
					if (t || n.container.styles.position !== 0 || !n.parent) {
						if (r.unshift.apply(r, i), t = [2, 3].indexOf(n.container.styles.position) === -1, n.container.styles.overflowX !== 0) {
							var a = Fc(n.curves), o = Lc(n.curves);
							Wc(a, o) || r.unshift(new zc(o, 6));
						}
					} else r.unshift.apply(r, i);
					n = n.parent;
				}
				return r.filter(function(t) {
					return W(t.target, e);
				});
			}, e;
		}(), Jc = function(e, t, n, r) {
			e.container.elements.forEach(function(i) {
				var a = W(i.flags, 4), o = W(i.flags, 2), s = new qc(i, e);
				W(i.styles.display, 2048) && r.push(s);
				var c = W(i.flags, 8) ? [] : r;
				if (a || o) {
					var l = a || i.styles.isPositioned() ? n : t, u = new Kc(s);
					if (i.styles.isPositioned() || i.styles.opacity < 1 || i.styles.isTransformed()) {
						var d = i.styles.zIndex.order;
						if (d < 0) {
							var f = 0;
							l.negativeZIndex.some(function(e, t) {
								return d > e.element.container.styles.zIndex.order ? (f = t, !1) : f > 0;
							}), l.negativeZIndex.splice(f, 0, u);
						} else if (d > 0) {
							var p = 0;
							l.positiveZIndex.some(function(e, t) {
								return d >= e.element.container.styles.zIndex.order ? (p = t + 1, !1) : p > 0;
							}), l.positiveZIndex.splice(p, 0, u);
						} else l.zeroOrAutoZIndexOrTransformedOrOpacity.push(u);
					} else i.styles.isFloating() ? l.nonPositionedFloats.push(u) : l.nonPositionedInlineLevel.push(u);
					Jc(s, u, a ? u : n, c);
				} else i.styles.isInlineLevel() ? t.inlineLevel.push(s) : t.nonInlineLevel.push(s), Jc(s, t, n, c);
				W(i.flags, 8) && Yc(i, c);
			});
		}, Yc = function(e, t) {
			for (var n = e instanceof es ? e.start : 1, r = e instanceof es ? e.reversed : !1, i = 0; i < t.length; i++) {
				var a = t[i];
				a.container instanceof $o && typeof a.container.value == "number" && a.container.value !== 0 && (n = a.container.value), a.listValue = nc(n, a.container.styles.listStyleType, !0), n += r ? -1 : 1;
			}
		}, Xc = function(e) {
			var t = new qc(e, null), n = new Kc(t), r = [];
			return Jc(t, n, n, r), Yc(t.container, r), n;
		}, Zc = function(e, t) {
			switch (t) {
				case 0: return $(e.topLeftBorderBox, e.topLeftPaddingBox, e.topRightBorderBox, e.topRightPaddingBox);
				case 1: return $(e.topRightBorderBox, e.topRightPaddingBox, e.bottomRightBorderBox, e.bottomRightPaddingBox);
				case 2: return $(e.bottomRightBorderBox, e.bottomRightPaddingBox, e.bottomLeftBorderBox, e.bottomLeftPaddingBox);
				default: return $(e.bottomLeftBorderBox, e.bottomLeftPaddingBox, e.topLeftBorderBox, e.topLeftPaddingBox);
			}
		}, Qc = function(e, t) {
			switch (t) {
				case 0: return $(e.topLeftBorderBox, e.topLeftBorderDoubleOuterBox, e.topRightBorderBox, e.topRightBorderDoubleOuterBox);
				case 1: return $(e.topRightBorderBox, e.topRightBorderDoubleOuterBox, e.bottomRightBorderBox, e.bottomRightBorderDoubleOuterBox);
				case 2: return $(e.bottomRightBorderBox, e.bottomRightBorderDoubleOuterBox, e.bottomLeftBorderBox, e.bottomLeftBorderDoubleOuterBox);
				default: return $(e.bottomLeftBorderBox, e.bottomLeftBorderDoubleOuterBox, e.topLeftBorderBox, e.topLeftBorderDoubleOuterBox);
			}
		}, $c = function(e, t) {
			switch (t) {
				case 0: return $(e.topLeftBorderDoubleInnerBox, e.topLeftPaddingBox, e.topRightBorderDoubleInnerBox, e.topRightPaddingBox);
				case 1: return $(e.topRightBorderDoubleInnerBox, e.topRightPaddingBox, e.bottomRightBorderDoubleInnerBox, e.bottomRightPaddingBox);
				case 2: return $(e.bottomRightBorderDoubleInnerBox, e.bottomRightPaddingBox, e.bottomLeftBorderDoubleInnerBox, e.bottomLeftPaddingBox);
				default: return $(e.bottomLeftBorderDoubleInnerBox, e.bottomLeftPaddingBox, e.topLeftBorderDoubleInnerBox, e.topLeftPaddingBox);
			}
		}, el = function(e, t) {
			switch (t) {
				case 0: return tl(e.topLeftBorderStroke, e.topRightBorderStroke);
				case 1: return tl(e.topRightBorderStroke, e.bottomRightBorderStroke);
				case 2: return tl(e.bottomRightBorderStroke, e.bottomLeftBorderStroke);
				default: return tl(e.bottomLeftBorderStroke, e.topLeftBorderStroke);
			}
		}, tl = function(e, t) {
			var n = [];
			return X(e) ? n.push(e.subdivide(.5, !1)) : n.push(e), X(t) ? n.push(t.subdivide(.5, !0)) : n.push(t), n;
		}, $ = function(e, t, n, r) {
			var i = [];
			return X(e) ? i.push(e.subdivide(.5, !1)) : i.push(e), X(n) ? i.push(n.subdivide(.5, !0)) : i.push(n), X(r) ? i.push(r.subdivide(.5, !0).reverse()) : i.push(r), X(t) ? i.push(t.subdivide(.5, !1).reverse()) : i.push(t), i;
		}, nl = function(e) {
			var t = e.bounds, n = e.styles;
			return t.add(n.borderLeftWidth, n.borderTopWidth, -(n.borderRightWidth + n.borderLeftWidth), -(n.borderTopWidth + n.borderBottomWidth));
		}, rl = function(e) {
			var t = e.styles, n = e.bounds, r = z(t.paddingLeft, n.width), i = z(t.paddingRight, n.width), a = z(t.paddingTop, n.width), o = z(t.paddingBottom, n.width);
			return n.add(r + t.borderLeftWidth, a + t.borderTopWidth, -(t.borderRightWidth + t.borderLeftWidth + r + i), -(t.borderTopWidth + t.borderBottomWidth + a + o));
		}, il = function(e, t) {
			return e === 0 ? t.bounds : e === 2 ? rl(t) : nl(t);
		}, al = function(e, t) {
			return e === 0 ? t.bounds : e === 2 ? rl(t) : nl(t);
		}, ol = function(e, t, n) {
			var r = il(ul(e.styles.backgroundOrigin, t), e), i = al(ul(e.styles.backgroundClip, t), e), a = ll(ul(e.styles.backgroundSize, t), n, r), o = a[0], s = a[1], c = lr(ul(e.styles.backgroundPosition, t), r.width - o, r.height - s);
			return [
				dl(ul(e.styles.backgroundRepeat, t), c, a, r, i),
				Math.round(r.left + c[0]),
				Math.round(r.top + c[1]),
				o,
				s
			];
		}, sl = function(e) {
			return F(e) && e.value === ri.AUTO;
		}, cl = function(e) {
			return typeof e == "number";
		}, ll = function(e, t, n) {
			var r = t[0], i = t[1], a = t[2], o = e[0], s = e[1];
			if (!o) return [0, 0];
			if (L(o) && s && L(s)) return [z(o, n.width), z(s, n.height)];
			var c = cl(a);
			if (F(o) && (o.value === ri.CONTAIN || o.value === ri.COVER)) return cl(a) ? n.width / n.height < a == (o.value === ri.COVER) ? [n.height * a, n.height] : [n.width, n.width / a] : [n.width, n.height];
			var l = cl(r), u = cl(i), d = l || u;
			if (sl(o) && (!s || sl(s))) return l && u ? [r, i] : !c && !d ? [n.width, n.height] : d && c ? [l ? r : i * a, u ? i : r / a] : [l ? r : n.width, u ? i : n.height];
			if (c) {
				var f = 0, p = 0;
				return L(o) ? f = z(o, n.width) : L(s) && (p = z(s, n.height)), sl(o) ? f = p * a : (!s || sl(s)) && (p = f / a), [f, p];
			}
			var m = null, h = null;
			if (L(o) ? m = z(o, n.width) : s && L(s) && (h = z(s, n.height)), m !== null && (!s || sl(s)) && (h = l && u ? m / r * i : n.height), h !== null && sl(o) && (m = l && u ? h / i * r : n.width), m !== null && h !== null) return [m, h];
			throw Error("Unable to calculate background-size for element");
		}, ul = function(e, t) {
			var n = e[t];
			return n === void 0 ? e[0] : n;
		}, dl = function(e, t, n, r, i) {
			var a = t[0], o = t[1], s = n[0], c = n[1];
			switch (e) {
				case 2: return [
					new Y(Math.round(r.left), Math.round(r.top + o)),
					new Y(Math.round(r.left + r.width), Math.round(r.top + o)),
					new Y(Math.round(r.left + r.width), Math.round(c + r.top + o)),
					new Y(Math.round(r.left), Math.round(c + r.top + o))
				];
				case 3: return [
					new Y(Math.round(r.left + a), Math.round(r.top)),
					new Y(Math.round(r.left + a + s), Math.round(r.top)),
					new Y(Math.round(r.left + a + s), Math.round(r.height + r.top)),
					new Y(Math.round(r.left + a), Math.round(r.height + r.top))
				];
				case 1: return [
					new Y(Math.round(r.left + a), Math.round(r.top + o)),
					new Y(Math.round(r.left + a + s), Math.round(r.top + o)),
					new Y(Math.round(r.left + a + s), Math.round(r.top + o + c)),
					new Y(Math.round(r.left + a), Math.round(r.top + o + c))
				];
				default: return [
					new Y(Math.round(i.left), Math.round(i.top)),
					new Y(Math.round(i.left + i.width), Math.round(i.top)),
					new Y(Math.round(i.left + i.width), Math.round(i.height + i.top)),
					new Y(Math.round(i.left), Math.round(i.height + i.top))
				];
			}
		}, fl = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", pl = "Hidden Text", ml = function() {
			function e(e) {
				this._data = {}, this._document = e;
			}
			return e.prototype.parseMetrics = function(e, t) {
				var n = this._document.createElement("div"), r = this._document.createElement("img"), i = this._document.createElement("span"), a = this._document.body;
				n.style.visibility = "hidden", n.style.fontFamily = e, n.style.fontSize = t, n.style.margin = "0", n.style.padding = "0", n.style.whiteSpace = "nowrap", a.appendChild(n), r.src = fl, r.width = 1, r.height = 1, r.style.margin = "0", r.style.padding = "0", r.style.verticalAlign = "baseline", i.style.fontFamily = e, i.style.fontSize = t, i.style.margin = "0", i.style.padding = "0", i.appendChild(this._document.createTextNode(pl)), n.appendChild(i), n.appendChild(r);
				var o = r.offsetTop - i.offsetTop + 2;
				n.removeChild(i), n.appendChild(this._document.createTextNode(pl)), n.style.lineHeight = "normal", r.style.verticalAlign = "super";
				var s = r.offsetTop - n.offsetTop + 2;
				return a.removeChild(n), {
					baseline: o,
					middle: s
				};
			}, e.prototype.getMetrics = function(e, t) {
				var n = e + " " + t;
				return this._data[n] === void 0 && (this._data[n] = this.parseMetrics(e, t)), this._data[n];
			}, e;
		}(), hl = function() {
			function e(e, t) {
				this.context = e, this.options = t;
			}
			return e;
		}(), gl = 1e4, _l = function(e) {
			t(n, e);
			function n(t, n) {
				var r = e.call(this, t, n) || this;
				return r._activeEffects = [], r.canvas = n.canvas ? n.canvas : document.createElement("canvas"), r.ctx = r.canvas.getContext("2d"), n.canvas || (r.canvas.width = Math.floor(n.width * n.scale), r.canvas.height = Math.floor(n.height * n.scale), r.canvas.style.width = n.width + "px", r.canvas.style.height = n.height + "px"), r.fontMetrics = new ml(document), r.ctx.scale(r.options.scale, r.options.scale), r.ctx.translate(-n.x, -n.y), r.ctx.textBaseline = "bottom", r._activeEffects = [], r.context.logger.debug("Canvas renderer initialized (" + n.width + "x" + n.height + ") with scale " + n.scale), r;
			}
			return n.prototype.applyEffects = function(e) {
				for (var t = this; this._activeEffects.length;) this.popEffect();
				e.forEach(function(e) {
					return t.applyEffect(e);
				});
			}, n.prototype.applyEffect = function(e) {
				this.ctx.save(), Uc(e) && (this.ctx.globalAlpha = e.opacity), Vc(e) && (this.ctx.translate(e.offsetX, e.offsetY), this.ctx.transform(e.matrix[0], e.matrix[1], e.matrix[2], e.matrix[3], e.matrix[4], e.matrix[5]), this.ctx.translate(-e.offsetX, -e.offsetY)), Hc(e) && (this.path(e.path), this.ctx.clip()), this._activeEffects.push(e);
			}, n.prototype.popEffect = function() {
				this._activeEffects.pop(), this.ctx.restore();
			}, n.prototype.renderStack = function(e) {
				return r(this, void 0, void 0, function() {
					var t;
					return i(this, function(n) {
						switch (n.label) {
							case 0: return t = e.element.container.styles, t.isVisible() ? [4, this.renderStackContent(e)] : [3, 2];
							case 1: n.sent(), n.label = 2;
							case 2: return [2];
						}
					});
				});
			}, n.prototype.renderNode = function(e) {
				return r(this, void 0, void 0, function() {
					return i(this, function(t) {
						switch (t.label) {
							case 0:
								if (W(e.container.flags, 16)) debugger;
								return e.container.styles.isVisible() ? [4, this.renderNodeBackgroundAndBorders(e)] : [3, 3];
							case 1: return t.sent(), [4, this.renderNodeContent(e)];
							case 2: t.sent(), t.label = 3;
							case 3: return [2];
						}
					});
				});
			}, n.prototype.renderTextWithLetterSpacing = function(e, t, n) {
				var r = this;
				t === 0 ? this.ctx.fillText(e.text, e.bounds.left, e.bounds.top + n) : Vo(e.text).reduce(function(t, i) {
					return r.ctx.fillText(i, t, e.bounds.top + n), t + r.ctx.measureText(i).width;
				}, e.bounds.left);
			}, n.prototype.createFontStyle = function(e) {
				var t = e.fontVariant.filter(function(e) {
					return e === "normal" || e === "small-caps";
				}).join(""), n = Sl(e.fontFamily).join(", "), r = Qn(e.fontSize) ? "" + e.fontSize.number + e.fontSize.unit : e.fontSize.number + "px";
				return [
					[
						e.fontStyle,
						t,
						e.fontWeight,
						r,
						n
					].join(" "),
					n,
					r
				];
			}, n.prototype.renderTextNode = function(e, t) {
				return r(this, void 0, void 0, function() {
					var n, r, a, o, s, c, l, u, d = this;
					return i(this, function(i) {
						return n = this.createFontStyle(t), r = n[0], a = n[1], o = n[2], this.ctx.font = r, this.ctx.direction = t.direction === 1 ? "rtl" : "ltr", this.ctx.textAlign = "left", this.ctx.textBaseline = "alphabetic", s = this.fontMetrics.getMetrics(a, o), c = s.baseline, l = s.middle, u = t.paintOrder, e.textBounds.forEach(function(e) {
							u.forEach(function(n) {
								switch (n) {
									case 0:
										d.ctx.fillStyle = V(t.color), d.renderTextWithLetterSpacing(e, t.letterSpacing, c);
										var r = t.textShadow;
										r.length && e.text.trim().length && (r.slice(0).reverse().forEach(function(n) {
											d.ctx.shadowColor = V(n.color), d.ctx.shadowOffsetX = n.offsetX.number * d.options.scale, d.ctx.shadowOffsetY = n.offsetY.number * d.options.scale, d.ctx.shadowBlur = n.blur.number, d.renderTextWithLetterSpacing(e, t.letterSpacing, c);
										}), d.ctx.shadowColor = "", d.ctx.shadowOffsetX = 0, d.ctx.shadowOffsetY = 0, d.ctx.shadowBlur = 0), t.textDecorationLine.length && (d.ctx.fillStyle = V(t.textDecorationColor || t.color), t.textDecorationLine.forEach(function(t) {
											switch (t) {
												case 1:
													d.ctx.fillRect(e.bounds.left, Math.round(e.bounds.top + c), e.bounds.width, 1);
													break;
												case 2:
													d.ctx.fillRect(e.bounds.left, Math.round(e.bounds.top), e.bounds.width, 1);
													break;
												case 3:
													d.ctx.fillRect(e.bounds.left, Math.ceil(e.bounds.top + l), e.bounds.width, 1);
													break;
											}
										}));
										break;
									case 1:
										t.webkitTextStrokeWidth && e.text.trim().length && (d.ctx.strokeStyle = V(t.webkitTextStrokeColor), d.ctx.lineWidth = t.webkitTextStrokeWidth, d.ctx.lineJoin = window.chrome ? "miter" : "round", d.ctx.strokeText(e.text, e.bounds.left, e.bounds.top + c)), d.ctx.strokeStyle = "", d.ctx.lineWidth = 0, d.ctx.lineJoin = "miter";
										break;
								}
							});
						}), [2];
					});
				});
			}, n.prototype.renderReplacedElement = function(e, t, n) {
				if (n && e.intrinsicWidth > 0 && e.intrinsicHeight > 0) {
					var r = rl(e), i = Lc(t);
					this.path(i), this.ctx.save(), this.ctx.clip(), this.ctx.drawImage(n, 0, 0, e.intrinsicWidth, e.intrinsicHeight, r.left, r.top, r.width, r.height), this.ctx.restore();
				}
			}, n.prototype.renderNodeContent = function(e) {
				return r(this, void 0, void 0, function() {
					var t, r, a, s, c, l, u, u, d, f, p, m, h, g, _, v, y, b, x, u, S, h, v;
					return i(this, function(i) {
						switch (i.label) {
							case 0: this.applyEffects(e.getEffects(4)), t = e.container, r = e.curves, a = t.styles, s = 0, c = t.textNodes, i.label = 1;
							case 1: return s < c.length ? (l = c[s], [4, this.renderTextNode(l, a)]) : [3, 4];
							case 2: i.sent(), i.label = 3;
							case 3: return s++, [3, 1];
							case 4:
								if (!(t instanceof Xo)) return [3, 8];
								i.label = 5;
							case 5: return i.trys.push([
								5,
								7,
								,
								8
							]), [4, this.context.cache.match(t.src)];
							case 6: return u = i.sent(), this.renderReplacedElement(t, r, u), [3, 8];
							case 7: return i.sent(), this.context.logger.error("Error loading image " + t.src), [3, 8];
							case 8:
								if (t instanceof Zo && this.renderReplacedElement(t, r, t.canvas), !(t instanceof Qo)) return [3, 12];
								i.label = 9;
							case 9: return i.trys.push([
								9,
								11,
								,
								12
							]), [4, this.context.cache.match(t.svg)];
							case 10: return u = i.sent(), this.renderReplacedElement(t, r, u), [3, 12];
							case 11: return i.sent(), this.context.logger.error("Error loading svg " + t.svg.substring(0, 255)), [3, 12];
							case 12: return t instanceof fs && t.tree ? (d = new n(this.context, {
								scale: this.options.scale,
								backgroundColor: t.backgroundColor,
								x: 0,
								y: 0,
								width: t.width,
								height: t.height
							}), [4, d.render(t.tree)]) : [3, 14];
							case 13: f = i.sent(), t.width && t.height && this.ctx.drawImage(f, 0, 0, t.width, t.height, t.bounds.left, t.bounds.top, t.bounds.width, t.bounds.height), i.label = 14;
							case 14:
								if (t instanceof ls && (p = Math.min(t.bounds.width, t.bounds.height), t.type === as ? t.checked && (this.ctx.save(), this.path([
									new Y(t.bounds.left + p * .39363, t.bounds.top + p * .79),
									new Y(t.bounds.left + p * .16, t.bounds.top + p * .5549),
									new Y(t.bounds.left + p * .27347, t.bounds.top + p * .44071),
									new Y(t.bounds.left + p * .39694, t.bounds.top + p * .5649),
									new Y(t.bounds.left + p * .72983, t.bounds.top + p * .23),
									new Y(t.bounds.left + p * .84, t.bounds.top + p * .34085),
									new Y(t.bounds.left + p * .39363, t.bounds.top + p * .79)
								]), this.ctx.fillStyle = V(cs), this.ctx.fill(), this.ctx.restore()) : t.type === os && t.checked && (this.ctx.save(), this.ctx.beginPath(), this.ctx.arc(t.bounds.left + p / 2, t.bounds.top + p / 2, p / 4, 0, Math.PI * 2, !0), this.ctx.fillStyle = V(cs), this.ctx.fill(), this.ctx.restore())), vl(t) && t.value.length) {
									switch (m = this.createFontStyle(a), h = m[0], g = m[1], _ = this.fontMetrics.getMetrics(h, g).baseline, this.ctx.font = h, this.ctx.fillStyle = V(a.color), this.ctx.textBaseline = "alphabetic", this.ctx.textAlign = bl(t.styles.textAlign), v = rl(t), y = 0, t.styles.textAlign) {
										case 1:
											y += v.width / 2;
											break;
										case 2:
											y += v.width;
											break;
									}
									b = v.add(y, 0, 0, -v.height / 2 + 1), this.ctx.save(), this.path([
										new Y(v.left, v.top),
										new Y(v.left + v.width, v.top),
										new Y(v.left + v.width, v.top + v.height),
										new Y(v.left, v.top + v.height)
									]), this.ctx.clip(), this.renderTextWithLetterSpacing(new Lo(t.value, b), a.letterSpacing, _), this.ctx.restore(), this.ctx.textBaseline = "alphabetic", this.ctx.textAlign = "left";
								}
								if (!W(t.styles.display, 2048)) return [3, 20];
								if (t.styles.listStyleImage === null) return [3, 19];
								if (x = t.styles.listStyleImage, x.type !== 0) return [3, 18];
								u = void 0, S = x.url, i.label = 15;
							case 15: return i.trys.push([
								15,
								17,
								,
								18
							]), [4, this.context.cache.match(S)];
							case 16: return u = i.sent(), this.ctx.drawImage(u, t.bounds.left - (u.width + 10), t.bounds.top), [3, 18];
							case 17: return i.sent(), this.context.logger.error("Error loading list-style-image " + S), [3, 18];
							case 18: return [3, 20];
							case 19: e.listValue && t.styles.listStyleType !== -1 && (h = this.createFontStyle(a)[0], this.ctx.font = h, this.ctx.fillStyle = V(a.color), this.ctx.textBaseline = "middle", this.ctx.textAlign = "right", v = new o(t.bounds.left, t.bounds.top + z(t.styles.paddingTop, t.bounds.width), t.bounds.width, Fi(a.lineHeight, a.fontSize.number) / 2 + 1), this.renderTextWithLetterSpacing(new Lo(e.listValue, v), a.letterSpacing, Fi(a.lineHeight, a.fontSize.number) / 2 + 2), this.ctx.textBaseline = "bottom", this.ctx.textAlign = "left"), i.label = 20;
							case 20: return [2];
						}
					});
				});
			}, n.prototype.renderStackContent = function(e) {
				return r(this, void 0, void 0, function() {
					var t, n, r, a, o, r, s, c, r, l, u, r, d, f, r, p, m, r, h, g, r;
					return i(this, function(i) {
						switch (i.label) {
							case 0:
								if (W(e.element.container.flags, 16)) debugger;
								return [4, this.renderNodeBackgroundAndBorders(e.element)];
							case 1: i.sent(), t = 0, n = e.negativeZIndex, i.label = 2;
							case 2: return t < n.length ? (r = n[t], [4, this.renderStack(r)]) : [3, 5];
							case 3: i.sent(), i.label = 4;
							case 4: return t++, [3, 2];
							case 5: return [4, this.renderNodeContent(e.element)];
							case 6: i.sent(), a = 0, o = e.nonInlineLevel, i.label = 7;
							case 7: return a < o.length ? (r = o[a], [4, this.renderNode(r)]) : [3, 10];
							case 8: i.sent(), i.label = 9;
							case 9: return a++, [3, 7];
							case 10: s = 0, c = e.nonPositionedFloats, i.label = 11;
							case 11: return s < c.length ? (r = c[s], [4, this.renderStack(r)]) : [3, 14];
							case 12: i.sent(), i.label = 13;
							case 13: return s++, [3, 11];
							case 14: l = 0, u = e.nonPositionedInlineLevel, i.label = 15;
							case 15: return l < u.length ? (r = u[l], [4, this.renderStack(r)]) : [3, 18];
							case 16: i.sent(), i.label = 17;
							case 17: return l++, [3, 15];
							case 18: d = 0, f = e.inlineLevel, i.label = 19;
							case 19: return d < f.length ? (r = f[d], [4, this.renderNode(r)]) : [3, 22];
							case 20: i.sent(), i.label = 21;
							case 21: return d++, [3, 19];
							case 22: p = 0, m = e.zeroOrAutoZIndexOrTransformedOrOpacity, i.label = 23;
							case 23: return p < m.length ? (r = m[p], [4, this.renderStack(r)]) : [3, 26];
							case 24: i.sent(), i.label = 25;
							case 25: return p++, [3, 23];
							case 26: h = 0, g = e.positiveZIndex, i.label = 27;
							case 27: return h < g.length ? (r = g[h], [4, this.renderStack(r)]) : [3, 30];
							case 28: i.sent(), i.label = 29;
							case 29: return h++, [3, 27];
							case 30: return [2];
						}
					});
				});
			}, n.prototype.mask = function(e) {
				this.ctx.beginPath(), this.ctx.moveTo(0, 0), this.ctx.lineTo(this.canvas.width, 0), this.ctx.lineTo(this.canvas.width, this.canvas.height), this.ctx.lineTo(0, this.canvas.height), this.ctx.lineTo(0, 0), this.formatPath(e.slice(0).reverse()), this.ctx.closePath();
			}, n.prototype.path = function(e) {
				this.ctx.beginPath(), this.formatPath(e), this.ctx.closePath();
			}, n.prototype.formatPath = function(e) {
				var t = this;
				e.forEach(function(e, n) {
					var r = X(e) ? e.start : e;
					n === 0 ? t.ctx.moveTo(r.x, r.y) : t.ctx.lineTo(r.x, r.y), X(e) && t.ctx.bezierCurveTo(e.startControl.x, e.startControl.y, e.endControl.x, e.endControl.y, e.end.x, e.end.y);
				});
			}, n.prototype.renderRepeat = function(e, t, n, r) {
				this.path(e), this.ctx.fillStyle = t, this.ctx.translate(n, r), this.ctx.fill(), this.ctx.translate(-n, -r);
			}, n.prototype.resizeImage = function(e, t, n) {
				if (e.width === t && e.height === n) return e;
				var r = (this.canvas.ownerDocument ?? document).createElement("canvas");
				return r.width = Math.max(1, t), r.height = Math.max(1, n), r.getContext("2d").drawImage(e, 0, 0, e.width, e.height, 0, 0, t, n), r;
			}, n.prototype.renderBackgroundImage = function(e) {
				return r(this, void 0, void 0, function() {
					var t, n, r, a, o, s;
					return i(this, function(c) {
						switch (c.label) {
							case 0: t = e.styles.backgroundImage.length - 1, n = function(n) {
								var a, o, s, c, l, u, d, f, p, m, c, l, u, d, f, h, g, _, v, y, b, x, S, C, p, w, c, T, E, d, f, D, l, u, O, ee, te, ne, re, ie, ae, oe;
								return i(this, function(i) {
									switch (i.label) {
										case 0:
											if (n.type !== 0) return [3, 5];
											a = void 0, o = n.url, i.label = 1;
										case 1: return i.trys.push([
											1,
											3,
											,
											4
										]), [4, r.context.cache.match(o)];
										case 2: return a = i.sent(), [3, 4];
										case 3: return i.sent(), r.context.logger.error("Error loading background-image " + o), [3, 4];
										case 4: return a && (s = ol(e, t, [
											a.width,
											a.height,
											a.width / a.height
										]), c = s[0], l = s[1], u = s[2], d = s[3], f = s[4], p = r.ctx.createPattern(r.resizeImage(a, d, f), "repeat"), r.renderRepeat(c, p, l, u)), [3, 6];
										case 5: qr(n) ? (m = ol(e, t, [
											null,
											null,
											null
										]), c = m[0], l = m[1], u = m[2], d = m[3], f = m[4], h = jr(n.angle, d, f), g = h[0], _ = h[1], v = h[2], y = h[3], b = h[4], x = document.createElement("canvas"), x.width = d, x.height = f, S = x.getContext("2d"), C = S.createLinearGradient(_, y, v, b), kr(n.stops, g).forEach(function(e) {
											return C.addColorStop(e.stop, V(e.color));
										}), S.fillStyle = C, S.fillRect(0, 0, d, f), d > 0 && f > 0 && (p = r.ctx.createPattern(x, "repeat"), r.renderRepeat(c, p, l, u))) : Jr(n) && (w = ol(e, t, [
											null,
											null,
											null
										]), c = w[0], T = w[1], E = w[2], d = w[3], f = w[4], D = n.position.length === 0 ? [sr] : n.position, l = z(D[0], d), u = z(D[D.length - 1], f), O = Nr(n, l, u, d, f), ee = O[0], te = O[1], ee > 0 && te > 0 && (ne = r.ctx.createRadialGradient(T + l, E + u, 0, T + l, E + u, ee), kr(n.stops, ee * 2).forEach(function(e) {
											return ne.addColorStop(e.stop, V(e.color));
										}), r.path(c), r.ctx.fillStyle = ne, ee === te ? r.ctx.fill() : (re = e.bounds.left + .5 * e.bounds.width, ie = e.bounds.top + .5 * e.bounds.height, ae = te / ee, oe = 1 / ae, r.ctx.save(), r.ctx.translate(re, ie), r.ctx.transform(1, 0, 0, ae, 0, 0), r.ctx.translate(-re, -ie), r.ctx.fillRect(T, oe * (E - ie) + ie, d, f * oe), r.ctx.restore()))), i.label = 6;
										case 6: return t--, [2];
									}
								});
							}, r = this, a = 0, o = e.styles.backgroundImage.slice(0).reverse(), c.label = 1;
							case 1: return a < o.length ? (s = o[a], [5, n(s)]) : [3, 4];
							case 2: c.sent(), c.label = 3;
							case 3: return a++, [3, 1];
							case 4: return [2];
						}
					});
				});
			}, n.prototype.renderSolidBorder = function(e, t, n) {
				return r(this, void 0, void 0, function() {
					return i(this, function(r) {
						return this.path(Zc(n, t)), this.ctx.fillStyle = V(e), this.ctx.fill(), [2];
					});
				});
			}, n.prototype.renderDoubleBorder = function(e, t, n, a) {
				return r(this, void 0, void 0, function() {
					var r, o;
					return i(this, function(i) {
						switch (i.label) {
							case 0: return t < 3 ? [4, this.renderSolidBorder(e, n, a)] : [3, 2];
							case 1: return i.sent(), [2];
							case 2: return r = Qc(a, n), this.path(r), this.ctx.fillStyle = V(e), this.ctx.fill(), o = $c(a, n), this.path(o), this.ctx.fill(), [2];
						}
					});
				});
			}, n.prototype.renderNodeBackgroundAndBorders = function(e) {
				return r(this, void 0, void 0, function() {
					var t, n, r, a, o, s, c, l, u = this;
					return i(this, function(i) {
						switch (i.label) {
							case 0: return this.applyEffects(e.getEffects(2)), t = e.container.styles, n = !vr(t.backgroundColor) || t.backgroundImage.length, r = [
								{
									style: t.borderTopStyle,
									color: t.borderTopColor,
									width: t.borderTopWidth
								},
								{
									style: t.borderRightStyle,
									color: t.borderRightColor,
									width: t.borderRightWidth
								},
								{
									style: t.borderBottomStyle,
									color: t.borderBottomColor,
									width: t.borderBottomWidth
								},
								{
									style: t.borderLeftStyle,
									color: t.borderLeftColor,
									width: t.borderLeftWidth
								}
							], a = yl(ul(t.backgroundClip, 0), e.curves), n || t.boxShadow.length ? (this.ctx.save(), this.path(a), this.ctx.clip(), vr(t.backgroundColor) || (this.ctx.fillStyle = V(t.backgroundColor), this.ctx.fill()), [4, this.renderBackgroundImage(e.container)]) : [3, 2];
							case 1: i.sent(), this.ctx.restore(), t.boxShadow.slice(0).reverse().forEach(function(t) {
								u.ctx.save();
								var n = Fc(e.curves), r = t.inset ? 0 : gl, i = Gc(n, -r + (t.inset ? 1 : -1) * t.spread.number, (t.inset ? 1 : -1) * t.spread.number, t.spread.number * (t.inset ? -2 : 2), t.spread.number * (t.inset ? -2 : 2));
								t.inset ? (u.path(n), u.ctx.clip(), u.mask(i)) : (u.mask(n), u.ctx.clip(), u.path(i)), u.ctx.shadowOffsetX = t.offsetX.number + r, u.ctx.shadowOffsetY = t.offsetY.number, u.ctx.shadowColor = V(t.color), u.ctx.shadowBlur = t.blur.number, u.ctx.fillStyle = t.inset ? V(t.color) : "rgba(0,0,0,1)", u.ctx.fill(), u.ctx.restore();
							}), i.label = 2;
							case 2: o = 0, s = 0, c = r, i.label = 3;
							case 3: return s < c.length ? (l = c[s], l.style !== 0 && !vr(l.color) && l.width > 0 ? l.style === 2 ? [4, this.renderDashedDottedBorder(l.color, l.width, o, e.curves, 2)] : [3, 5] : [3, 11]) : [3, 13];
							case 4: return i.sent(), [3, 11];
							case 5: return l.style === 3 ? [4, this.renderDashedDottedBorder(l.color, l.width, o, e.curves, 3)] : [3, 7];
							case 6: return i.sent(), [3, 11];
							case 7: return l.style === 4 ? [4, this.renderDoubleBorder(l.color, l.width, o, e.curves)] : [3, 9];
							case 8: return i.sent(), [3, 11];
							case 9: return [4, this.renderSolidBorder(l.color, o, e.curves)];
							case 10: i.sent(), i.label = 11;
							case 11: o++, i.label = 12;
							case 12: return s++, [3, 3];
							case 13: return [2];
						}
					});
				});
			}, n.prototype.renderDashedDottedBorder = function(e, t, n, a, o) {
				return r(this, void 0, void 0, function() {
					var r, s, c, l, u, d, f, p, m, h, g, _, v, y, b, x, b, x;
					return i(this, function(i) {
						return this.ctx.save(), r = el(a, n), s = Zc(a, n), o === 2 && (this.path(s), this.ctx.clip()), X(s[0]) ? (c = s[0].start.x, l = s[0].start.y) : (c = s[0].x, l = s[0].y), X(s[1]) ? (u = s[1].end.x, d = s[1].end.y) : (u = s[1].x, d = s[1].y), f = Math.abs(n === 0 || n === 2 ? c - u : l - d), this.ctx.beginPath(), o === 3 ? this.formatPath(r) : this.formatPath(s.slice(0, 2)), p = t < 3 ? t * 3 : t * 2, m = t < 3 ? t * 2 : t, o === 3 && (p = t, m = t), h = !0, f <= p * 2 ? h = !1 : f <= p * 2 + m ? (g = f / (2 * p + m), p *= g, m *= g) : (_ = Math.floor((f + m) / (p + m)), v = (f - _ * p) / (_ - 1), y = (f - (_ + 1) * p) / _, m = y <= 0 || Math.abs(m - v) < Math.abs(m - y) ? v : y), h && (o === 3 ? this.ctx.setLineDash([0, p + m]) : this.ctx.setLineDash([p, m])), o === 3 ? (this.ctx.lineCap = "round", this.ctx.lineWidth = t) : this.ctx.lineWidth = t * 2 + 1.1, this.ctx.strokeStyle = V(e), this.ctx.stroke(), this.ctx.setLineDash([]), o === 2 && (X(s[0]) && (b = s[3], x = s[0], this.ctx.beginPath(), this.formatPath([new Y(b.end.x, b.end.y), new Y(x.start.x, x.start.y)]), this.ctx.stroke()), X(s[1]) && (b = s[1], x = s[2], this.ctx.beginPath(), this.formatPath([new Y(b.end.x, b.end.y), new Y(x.start.x, x.start.y)]), this.ctx.stroke())), this.ctx.restore(), [2];
					});
				});
			}, n.prototype.render = function(e) {
				return r(this, void 0, void 0, function() {
					var t;
					return i(this, function(n) {
						switch (n.label) {
							case 0: return this.options.backgroundColor && (this.ctx.fillStyle = V(this.options.backgroundColor), this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height)), t = Xc(e), [4, this.renderStack(t)];
							case 1: return n.sent(), this.applyEffects([]), [2, this.canvas];
						}
					});
				});
			}, n;
		}(hl), vl = function(e) {
			return e instanceof ds || e instanceof us ? !0 : e instanceof ls && e.type !== os && e.type !== as;
		}, yl = function(e, t) {
			switch (e) {
				case 0: return Fc(t);
				case 2: return Ic(t);
				default: return Lc(t);
			}
		}, bl = function(e) {
			switch (e) {
				case 1: return "center";
				case 2: return "right";
				default: return "left";
			}
		}, xl = ["-apple-system", "system-ui"], Sl = function(e) {
			return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? e.filter(function(e) {
				return xl.indexOf(e) === -1;
			}) : e;
		}, Cl = function(e) {
			t(n, e);
			function n(t, n) {
				var r = e.call(this, t, n) || this;
				return r.canvas = n.canvas ? n.canvas : document.createElement("canvas"), r.ctx = r.canvas.getContext("2d"), r.options = n, r.canvas.width = Math.floor(n.width * n.scale), r.canvas.height = Math.floor(n.height * n.scale), r.canvas.style.width = n.width + "px", r.canvas.style.height = n.height + "px", r.ctx.scale(r.options.scale, r.options.scale), r.ctx.translate(-n.x, -n.y), r.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + n.width + "x" + n.height + " at " + n.x + "," + n.y + ") with scale " + n.scale), r;
			}
			return n.prototype.render = function(e) {
				return r(this, void 0, void 0, function() {
					var t, n;
					return i(this, function(r) {
						switch (r.label) {
							case 0: return t = Fo(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, e), [4, wl(t)];
							case 1: return n = r.sent(), this.options.backgroundColor && (this.ctx.fillStyle = V(this.options.backgroundColor), this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale)), this.ctx.drawImage(n, -this.options.x * this.options.scale, -this.options.y * this.options.scale), [2, this.canvas];
						}
					});
				});
			}, n;
		}(hl), wl = function(e) {
			return new Promise(function(t, n) {
				var r = new Image();
				r.onload = function() {
					t(r);
				}, r.onerror = n, r.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(e));
			});
		}, Tl = function() {
			function e(e) {
				var t = e.id, n = e.enabled;
				this.id = t, this.enabled = n, this.start = Date.now();
			}
			return e.prototype.debug = function() {
				var e = [...arguments];
				this.enabled && (typeof window < "u" && window.console && typeof console.debug == "function" ? console.debug.apply(console, a([this.id, this.getTime() + "ms"], e)) : this.info.apply(this, e));
			}, e.prototype.getTime = function() {
				return Date.now() - this.start;
			}, e.prototype.info = function() {
				var e = [...arguments];
				this.enabled && typeof window < "u" && window.console && typeof console.info == "function" && console.info.apply(console, a([this.id, this.getTime() + "ms"], e));
			}, e.prototype.warn = function() {
				var e = [...arguments];
				this.enabled && (typeof window < "u" && window.console && typeof console.warn == "function" ? console.warn.apply(console, a([this.id, this.getTime() + "ms"], e)) : this.info.apply(this, e));
			}, e.prototype.error = function() {
				var e = [...arguments];
				this.enabled && (typeof window < "u" && window.console && typeof console.error == "function" ? console.error.apply(console, a([this.id, this.getTime() + "ms"], e)) : this.info.apply(this, e));
			}, e.instances = {}, e;
		}(), El = function() {
			function e(t, n) {
				this.windowBounds = n, this.instanceName = "#" + e.instanceCount++, this.logger = new Tl({
					id: this.instanceName,
					enabled: t.logging
				}), this.cache = t.cache ?? new Cc(this, t);
			}
			return e.instanceCount = 1, e;
		}(), Dl = function(e, t) {
			return t === void 0 && (t = {}), Ol(e, t);
		};
		typeof window < "u" && Sc.setContext(window);
		var Ol = function(e, t) {
			return r(void 0, void 0, void 0, function() {
				var r, a, l, u, d, f, p, m, h, g, _, v, y, b, x, S, C, w, T, E, D, O, D;
				return i(this, function(i) {
					switch (i.label) {
						case 0:
							if (!e || typeof e != "object") return [2, Promise.reject("Invalid element provided as first argument")];
							if (r = e.ownerDocument, !r) throw Error("Element is not attached to a Document");
							if (a = r.defaultView, !a) throw Error("Document is not attached to a Window");
							return l = {
								allowTaint: t.allowTaint ?? !1,
								imageTimeout: t.imageTimeout ?? 15e3,
								proxy: t.proxy,
								useCORS: t.useCORS ?? !1
							}, u = n({
								logging: t.logging ?? !0,
								cache: t.cache
							}, l), d = {
								windowWidth: t.windowWidth ?? a.innerWidth,
								windowHeight: t.windowHeight ?? a.innerHeight,
								scrollX: t.scrollX ?? a.pageXOffset,
								scrollY: t.scrollY ?? a.pageYOffset
							}, f = new o(d.scrollX, d.scrollY, d.windowWidth, d.windowHeight), p = new El(u, f), m = t.foreignObjectRendering ?? !1, h = {
								allowTaint: t.allowTaint ?? !1,
								onclone: t.onclone,
								ignoreElements: t.ignoreElements,
								inlineImages: m,
								copyStyles: m
							}, p.logger.debug("Starting document clone with size " + f.width + "x" + f.height + " scrolled to " + -f.left + "," + -f.top), g = new ic(p, e, h), _ = g.clonedReferenceElement, _ ? [4, g.toIFrame(r, f)] : [2, Promise.reject("Unable to find element in cloned iframe")];
						case 1: return v = i.sent(), y = Os(_) || Es(_) ? c(_.ownerDocument) : s(p, _), b = y.width, x = y.height, S = y.left, C = y.top, w = kl(p, _, t.backgroundColor), T = {
							canvas: t.canvas,
							backgroundColor: w,
							scale: t.scale ?? a.devicePixelRatio ?? 1,
							x: (t.x ?? 0) + S,
							y: (t.y ?? 0) + C,
							width: t.width ?? Math.ceil(b),
							height: t.height ?? Math.ceil(x)
						}, m ? (p.logger.debug("Document cloned, using foreign object rendering"), D = new Cl(p, T), [4, D.render(_)]) : [3, 3];
						case 2: return E = i.sent(), [3, 5];
						case 3: return p.logger.debug("Document cloned, element located at " + S + "," + C + " with size " + b + "x" + x + " using computed rendering"), p.logger.debug("Starting DOM parsing"), O = gs(p, _), w === O.styles.backgroundColor && (O.styles.backgroundColor = H.TRANSPARENT), p.logger.debug("Starting renderer for element at " + T.x + "," + T.y + " with size " + T.width + "x" + T.height), D = new _l(p, T), [4, D.render(O)];
						case 4: E = i.sent(), i.label = 5;
						case 5: return (t.removeContainer ?? !0) && (ic.destroy(v) || p.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore")), p.logger.debug("Finished rendering"), [2, E];
					}
				});
			});
		}, kl = function(e, t, n) {
			var r = t.ownerDocument, i = r.documentElement ? Tr(e, getComputedStyle(r.documentElement).backgroundColor) : H.TRANSPARENT, a = r.body ? Tr(e, getComputedStyle(r.body).backgroundColor) : H.TRANSPARENT, o = typeof n == "string" ? Tr(e, n) : n === null ? H.TRANSPARENT : 4294967295;
			return t === r.documentElement ? vr(i) ? vr(a) ? o : a : i : o;
		};
		return Dl;
	}));
}));
//#endregion
export default t();

//# sourceMappingURL=html2canvas-DhrjCa5K.js.map